import React from "react"
import { AppLink } from "@ecom/ui/components/AppLink"

export const QUESTIONS = [
  {
    question: "На чем зарабатывает банк, если мне не нужно платить проценты? В чем подвох?",
    answer:
      "На самом деле никакого подвоха со стороны банка нет – схема максимально прозрачна. Вы покупаете товары у партнеров банка – магазины получают новых клиентов. Проценты вместо вас платит магазин, поэтому свою выгоду получает и банк. Клиент тоже остается в плюсе, поскольку не переплачивает за пользование рассрочкой* и получает товар без наценки. ",
  },
  {
    question: "Процентная ставка по рассрочке*",
    answer:
      "Поскольку мы предлагаем вам беспроцентную рассрочку*, то и процентная ставка по ней составит 0%. Она будет действовать в течение всего льготного периода (36 месяцев). После его окончания ставка будет равна 0,0001%.",
  },
  {
    question: "Халва – кредитная или дебетовая карта?",
    answer:
      "Халва – универсальная карта, которую можно использовать одновременно как дебетовую и карту рассрочки*. Сменить режим можно легко в приложении «Халва – Совкомбанк». ",
  },
  {
    question: "Какой у карты срок действия?",
    answer:
      "Халва будет действовать до последнего дня того месяца, который указан на лицевой стороне карты. Договор действителен в течение 10 лет, но сам пластик будет активен только 5 лет. Спустя это время мы бесплатно перевыпустим вам карту. Об истечении срока пластика и дате изготовления банк сообщит заранее. ",
  },
  {
    question: "Что будет, если просрочить ежемесячный платеж?",
    answer:
      "При просрочке от одного до пяти дней никаких санкций не предусмотрено. С шестого дня просрочки будут начислять 0,1 % от суммы просроченной задолженности за каждый день нарушения обязательств.",
  },
  {
    question: "Какой минимальный и максимальный лимит рассрочки*?",
    answer:
      "На балансе Халвы может быть от 15 000 рублей заемных средств. Но количество доступных средств бывает и значительно больше. Максимум — 500 000 рублей.",
  },
  {
    question: "Как получить справки и выписки?",
    answer: (
      <>
        Получить справки и выписки по Халве можно несколькими способами:{" "}
        <ul>
          <li>Посетить банк и получить необходимые данные в отделении;</li>{" "}
          <li>
            Запросить выписки через приложение в телефоне или личный кабинет{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://halvacard.ru/lk"
            >
              на сайте «Халвы».
            </AppLink>
          </li>
        </ul>
      </>
    ),
  },
  {
    question: "Мои деньги на карте застрахованы?",
    answer: (
      <>
        Собственные средства клиента на карте застрахованы согласно{" "}
        <AppLink
          rel="nofollow noopener noreferrer"
          target="_blank"
          href="https://www.consultant.ru/document/cons_doc_LAW_45769/"
        >
          ФЗ&nbsp;№177-ФЗ
        </AppLink>
        .
      </>
    ),
  },
  {
    question: "Есть ли платные услуги, которые подключены по умолчанию?",
    answer: "Нет, все услуги мы подключаем с согласия клиента. Они не являются обязательными.",
  },
  {
    question: "Влияет ли наличие карты на кредитную нагрузку?",
    answer:
      "Поскольку с помощью Халвы вы покупаете товары в рассрочку*, наличие задолженности по карте влияет на кредитную нагрузку. Банк будет относиться к вам более лояльно, если вы будете активно пользоваться картой и своевременно вносить платежи.  ",
  },
  {
    question: "Буду ли я получать уведомления об операциях по карте? Сколько это стоит?",
    answer: (
      <>
        По всем операциям на вашей карте будут поступать уведомления. Для этого включите
        push-уведомления в приложении. <br /> <br /> Помимо этого, вы можете получать
        СМС-оповещения. Они будут бесплатными, если вы будете соблюдать два простых условия:
        заходить в приложение банка или личный кабинет на сайте Халвы не менее трех раз в месяц и не
        отключать push-уведомления в приложении. В ином случае СМС-оповещение станет платным и
        составит 99 рублей. <br /> <br /> Для клиентов банка старше 50 лет и тех, кто получил, но
        еще не воспользовался картой, СМС-уведомления бесплатные.
      </>
    ),
  },
  {
    question: "Насколько надежен банк, который выпускает карту? Где о нем можно узнать информацию?",
    answer: (
      <>
        Халва — это проект Совкомбанка. Вся информация о его надежности — лицензии, реквизиты,
        рейтинги финансовой организации — собрана на{" "}
        <AppLink
          rel="nofollow noopener noreferrer"
          target="_blank"
          href="https://scb.ru/about/info"
        >
          отдельной странице
        </AppLink>
        .<br />
        <br /> Совкомбанк зарекомендовал себя как надежная организация и не раз лидировал в народных
        рейтингах:{" "}
        <ul>
          <li>
            в 2018 году «Халву»{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://finelita.ru/novosti/obyavleny-laureaty-xiv-premii-finansovaya-elita-rossii-2018.html"
            >
              признали
            </AppLink>{" "}
            лучшей банковской картой года, лауреат премии «Финансовая элита России»;
          </li>
          <li>
            по итогам 2024 года банк{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://www.banki.ru/services/responses/?date=2024"
            >
              возглавил
            </AppLink>{" "}
            «Народный рейтинг» портала «
            <AppLink rel="nofollow noopener noreferrer" target="_blank" href="http://banki.ru">
              Банки.ру
            </AppLink>
            », а до 2022{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://scb.ru/articles/novosti-kompanii/sovkombank-priznan-pobeditelem-narodnogo-reitinga-banki-ru-po-itogam-2022-goda"
            >
              занимал
            </AppLink>{" "}
            в нем первое место четыре года подряд;
          </li>
          <li>
            в 2024 году Совкомбанк первый в{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://www.sravni.ru/banki/rating/karty/"
            >
              рейтинге
            </AppLink>{" "}
            кредитных карт России по версии «
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://www.sravni.ru"
            >
              Сравни»
            </AppLink>{" "}
            (⭑4.91/5.00).
          </li>
        </ul>
      </>
    ),
  },
  {
    question: "Как получить ПИН-код карты?",
    answer:
      "Вы получите пластиковую карту в запечатанном конверте вместе с документами и инструкцией. Там же вы найдете ПИН-код от Халвы. При необходимости вы можете установить его самостоятельно. Для этого нужно открыть приложение или зайти в личный кабинет на сайте карты «Халва». ",
  },
  {
    question: "Как изменить ПИН-код?",
    answer: (
      <>
        Сменить ПИН-код можно через приложение. Сначала выберите карту и перейдите в раздел «Важно».
        Затем перейдите в «Действия» и нажмите «Сменить ПИН-код». <br /> <br /> Также вы можете
        сменить пароль, позвонив по телефону бесплатной и круглосуточной горячей линии банка:
        8-800-100-00-06.
      </>
    ),
  },
  {
    question: "Забыл ПИН-код Халвы – что делать?",
    answer: (
      <>
        Если вы забыли ПИН-код от карты, то его можно легко поменять в приложении «Халва –
        Совкомбанк». Для этого выберите нужную карту, затем перейдите в раздел «Важно», «Действия» и
        «Сменить ПИН-код». Введите новый пароль и подтвердите его. <br /> <br /> Вы также можете
        сменить его, если позвоните по телефону бесплатной и круглосуточной горячей линии банка:
        8-800-100-00-06. <br /> <br /> Также вы можете обратиться в отделение банка. Не забудьте
        взять с собой паспорт.
      </>
    ),
  },
  {
    question: "Где я могу найти реквизиты моей Халвы и других карт?",
    answer:
      "Реквизиты карты можно найти в приложении банка. Достаточно зайти в раздел «Важно» и выбрать «Реквизиты карты». Также информацию можно найти в личном кабинете на сайте Халвы, выбрав раздел «Важно» и «О карте».",
  },
]

export const QUESTIONS_FOR_PKW = [
  {
    question: "На чем зарабатывает банк, если мне не нужно платить проценты? В чем подвох?",
    answer:
      "На самом деле никакого подвоха со стороны банка нет – схема максимально прозрачна. Вы покупаете товары у партнеров банка – магазины получают новых клиентов. Проценты вместо вас платит магазин, поэтому свою выгоду получает и банк. Клиент тоже остается в плюсе, поскольку не переплачивает за пользование рассрочкой* и получает товар без наценки. ",
  },
  {
    question: "Процентная ставка по рассрочке*",
    answer:
      "Поскольку мы предлагаем вам беспроцентную рассрочку, то и процентная ставка по ней составит 0%. Она будет действовать в течение всего льготного периода (36 месяцев). После его окончания ставка будет равна 0,0001%.",
  },
  {
    question: "Халва – кредитная или дебетовая карта?",
    answer:
      "Халва – универсальная карта, которую можно использовать одновременно как дебетовую и карту рассрочки*. Сменить режим можно легко в приложении «Халва – Совкомбанк». ",
  },
  {
    question: "Какой у карты срок действия?",
    answer:
      "Срок действия карты Рассрочки*  Халва  7 лет. В конце срока предусмотрен автоматический перевыпуск.  Достаточно будет прийти за новой картой с паспортом в любое отделение банка.  Перевыпуск и обслуживание карты Совкомбанка полностью бесплатные.",
  },
  {
    question: "Что будет, если просрочить ежемесячный платеж?",
    answer:
      "При просрочке от одного до пяти дней никаких санкций не предусмотрено. С шестого дня просрочки будут начислять 0,1 % от суммы просроченной задолженности за каждый день нарушения обязательств.",
  },
  {
    question: "Какой минимальный и максимальный лимит рассрочки*?",
    answer:
      "На балансе Халвы может быть от 15 000 рублей заемных средств. Но количество доступных средств бывает и значительно больше. Максимум — 500 000 рублей.",
  },
  {
    question: "Как получить справки и выписки?",
    answer: (
      <>
        Получить справки и выписки по Халве можно несколькими способами:{" "}
        <ul>
          <li>Посетить банк и получить необходимые данные в отделении;</li>{" "}
          <li>
            Запросить выписки через приложение в телефоне или личный кабинет{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://halvacard.ru/lk"
            >
              на сайте «Халвы».
            </AppLink>
          </li>
        </ul>
      </>
    ),
  },
  {
    question: "Мои деньги на карте застрахованы?",
    answer: (
      <>
        Собственные средства клиента на карте застрахованы согласно{" "}
        <AppLink
          rel="nofollow noopener noreferrer"
          target="_blank"
          href="https://www.consultant.ru/document/cons_doc_LAW_45769/"
        >
          ФЗ&nbsp;№177-ФЗ
        </AppLink>
        .
      </>
    ),
  },
  {
    question: "Есть ли платные услуги, которые подключены по умолчанию?",
    answer: "Нет, все услуги мы подключаем с согласия клиента. Они не являются обязательными.",
  },
  {
    question: "Влияет ли наличие карты на кредитную нагрузку?",
    answer:
      "Поскольку с помощью Халвы вы покупаете товары в рассрочку*, наличие задолженности по карте влияет на кредитную нагрузку. Банк будет относиться к вам более лояльно, если вы будете активно пользоваться картой и своевременно вносить платежи.  ",
  },
  {
    question: "Буду ли я получать уведомления об операциях по карте? Сколько это стоит?",
    answer: (
      <>
        По всем операциям на вашей карте будут поступать уведомления. Для этого включите
        push-уведомления в приложении. <br /> <br /> Помимо этого, вы можете получать
        СМС-оповещения. Они будут бесплатными, если вы будете соблюдать два простых условия:
        заходить в приложение банка или личный кабинет на сайте Халвы не менее трех раз в месяц и не
        отключать push-уведомления в приложении. В ином случае СМС-оповещение станет платным и
        составит 99 рублей. <br /> <br /> Для клиентов банка старше 50 лет и тех, кто получил, но
        еще не воспользовался картой, СМС-уведомления бесплатные.
      </>
    ),
  },
  {
    question: "Насколько надежен банк, который выпускает карту? Где о нем можно узнать информацию?",
    answer: (
      <>
        Халва — это проект Совкомбанка. Вся информация о его надежности — лицензии, реквизиты,
        рейтинги финансовой организации — собрана на{" "}
        <AppLink
          rel="nofollow noopener noreferrer"
          target="_blank"
          href="https://scb.ru/about/info"
        >
          отдельной странице
        </AppLink>
        .<br />
        <br /> Совкомбанк зарекомендовал себя как надежная организация и не раз лидировал в народных
        рейтингах:{" "}
        <ul>
          <li>
            в 2018 году «Халву»{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://finelita.ru/novosti/obyavleny-laureaty-xiv-premii-finansovaya-elita-rossii-2018.html"
            >
              признали
            </AppLink>{" "}
            лучшей банковской картой года, лауреат премии «Финансовая элита России»;
          </li>
          <li>
            по итогам 2024 года банк{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://www.banki.ru/services/responses/?date=2024"
            >
              возглавил
            </AppLink>{" "}
            «Народный рейтинг» портала «
            <AppLink rel="nofollow noopener noreferrer" target="_blank" href="http://banki.ru">
              Банки.ру
            </AppLink>
            », а до 2022{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://scb.ru/articles/novosti-kompanii/sovkombank-priznan-pobeditelem-narodnogo-reitinga-banki-ru-po-itogam-2022-goda"
            >
              занимал
            </AppLink>{" "}
            в нем первое место четыре года подряд;
          </li>
          <li>
            в 2024 году Совкомбанк первый в{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://www.sravni.ru/banki/rating/karty/"
            >
              рейтинге
            </AppLink>{" "}
            кредитных карт России по версии «
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://www.sravni.ru"
            >
              Сравни»
            </AppLink>{" "}
            (⭑4.91/5.00).
          </li>
        </ul>
      </>
    ),
  },
  {
    question: "Как получить ПИН-код карты?",
    answer:
      "Вы получите пластиковую карту в запечатанном конверте вместе с документами и инструкцией. Там же вы найдете ПИН-код от Халвы. При необходимости вы можете установить его самостоятельно. Для этого нужно открыть приложение или зайти в личный кабинет на сайте карты «Халва». ",
  },
  {
    question: "Как изменить ПИН-код?",
    answer: (
      <>
        Cменить пин-код самостоятельно в Мобильном приложении.
        <br /> <br /> Cменить пин-код самостоятельно через Чат-Банк. <br /> <br />
        Клиенту необходимо обратиться в офис ПАО Совкомбанк лично с паспортом и оставить письменное
        заявление на смену PIN-кода. Далее Вам будет предложено перезвонить с номера, указанного в
        заявлении, на номер 8-800-100-0006 и нажать цифру 4.
      </>
    ),
  },
  {
    question: "Забыл ПИН-код Халвы – что делать?",
    answer: (
      <>
        Если вы забыли ПИН-код от карты, то его можно легко поменять в приложении «Халва –
        Совкомбанк». Для этого выберите нужную карту, затем перейдите в раздел «Важно», «Действия» и
        «Сменить ПИН-код». Введите новый пароль и подтвердите его. <br /> <br /> Вы также можете
        сменить его, если позвоните по телефону бесплатной и круглосуточной горячей линии банка:
        8-800-100-00-06. <br /> <br /> Также вы можете обратиться в отделение банка. Не забудьте
        взять с собой паспорт.
      </>
    ),
  },
  {
    question: "Где я могу найти реквизиты моей Халвы и других карт?",
    answer:
      "Реквизиты карты можно найти в приложении банка. Достаточно зайти в раздел «Важно» и выбрать «Реквизиты карты». Также информацию можно найти в личном кабинете на сайте Халвы, выбрав раздел «Важно» и «О карте».",
  },
]

export const QUESTIONS_FOR_INDEX_PKW = [
  {
    question: "Халва – кредитная или дебетовая карта?",
    answer:
      "Халва – универсальная карта, которую можно использовать одновременно как дебетовую и карту рассрочки*. Сменить режим можно легко в приложении «Халва – Совкомбанк». ",
  },
  {
    question: "Какой минимальный и максимальный лимит рассрочки*?",
    answer:
      "Минимальный лимит по карте «Халва» — 15 000 руб. Максимальный лимит составляет 500 000 руб.",
  },
  {
    question: "Влияет ли наличие карты на кредитную нагрузку?",
    answer:
      "Поскольку с помощью Халвы вы покупаете товары в рассрочку*, наличие задолженности по карте влияет на кредитную нагрузку. Банк будет относиться к вам более лояльно, если вы будете активно пользоваться картой и своевременно вносить платежи.  ",
  },
  {
    question: "Насколько надежен банк, который выпускает карту? Где о нем можно узнать информацию?",
    answer: (
      <>
        Халва — это проект Совкомбанка. Вся информация о его надежности — лицензии, реквизиты,
        рейтинги финансовой организации — собрана на{" "}
        <AppLink
          rel="nofollow noopener noreferrer"
          target="_blank"
          href="https://scb.ru/about/info"
        >
          отдельной странице
        </AppLink>
        .<br />
        <br /> Совкомбанк зарекомендовал себя как надежная организация и не раз лидировал в народных
        рейтингах:{" "}
        <ul>
          <li>
            в 2018 году «Халву»{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://finelita.ru/novosti/obyavleny-laureaty-xiv-premii-finansovaya-elita-rossii-2018.html"
            >
              признали
            </AppLink>{" "}
            лучшей банковской картой года, лауреат премии «Финансовая элита России»;
          </li>
          <li>
            по итогам 2024 года банк{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://www.banki.ru/services/responses/?date=2024"
            >
              возглавил
            </AppLink>{" "}
            «Народный рейтинг» портала «
            <AppLink rel="nofollow noopener noreferrer" target="_blank" href="http://banki.ru">
              Банки.ру
            </AppLink>
            », а до 2022{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://scb.ru/articles/novosti-kompanii/sovkombank-priznan-pobeditelem-narodnogo-reitinga-banki-ru-po-itogam-2022-goda"
            >
              занимал
            </AppLink>{" "}
            в нем первое место четыре года подряд;
          </li>
          <li>
            в 2024 году Совкомбанк первый в{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://www.sravni.ru/banki/rating/karty/"
            >
              рейтинге
            </AppLink>{" "}
            кредитных карт России по версии «
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://www.sravni.ru"
            >
              Сравни»
            </AppLink>{" "}
            (⭑4.91/5.00).
          </li>
        </ul>
      </>
    ),
  },
  {
    question: "Что такое подписка «Халва.Десятка»?",
    answer: (
      <>
        Это платная услуга, с&nbsp;которой вы получаете дополнительные преимущества:
        <ul>
          <li>
            <b>10 месяцев рассрочки на&nbsp;покупки.*</b> Единый увеличенный срок рассрочки*
            в&nbsp;260&nbsp;000{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://halvacard.ru/shops/special"
            >
              магазинах-партнёрах
            </AppLink>{" "}
            Халвы*;
          </li>
          <li>
            <b>
              Удвоение{" "}
              <AppLink
                rel="nofollow noopener noreferrer"
                target="_blank"
                href="https://scb.ru/document?id=2777"
              >
                кэшбэка
              </AppLink>
              .
            </b>{" "}
            В 2 раза больше кэшбэка за&nbsp;каждую покупку или поездку на Яндекс GO – возвращайте
            до&nbsp;10% от&nbsp;стоимости;
          </li>
          <li>
            <b>Увеличенный лимит кешбэка в&nbsp;месяц&nbsp;5&nbsp;000.</b> Получайте больше кешбэка
            по&nbsp;карте*****;
          </li>
          <li>
            <b>+5% к&nbsp;ставке вкладов.</b> Увеличение** на&nbsp;+5% по&nbsp;вкладам на&nbsp;сроке
            36&nbsp;мес., +2% на&nbsp;сроке 24 мес. (+1% на&nbsp;других сроках) при ежемесячном
            выполнении условия: от&nbsp;10 покупок по&nbsp;Халве на&nbsp;общую сумму
            от&nbsp;20&nbsp;000&nbsp;₽.***;
          </li>
          <li>
            <b>+1% к ставке Онлайн-копилки.</b> Увеличение базовой ставки***;
          </li>
          <li>
            <b>+1 месяц рассрочки*.</b> На снятия, переводы и&nbsp;покупки заёмными средствами
            не&nbsp;у&nbsp;партнеров;
          </li>
          <li>
            <b>Бесплатный стикер Рау.</b> Для удобной оплаты телефоном и&nbsp;повышенного кэшбэка;
          </li>
          <li>
            <b>Комплексная IT-защита.</b> Онлайн-консультация эксперта при неисправностях и сбоях в
            работе компьютера или смартфона;
          </li>
          <li>
            <b>Помощник по&nbsp;покупкам.</b> Личный консультант подберет для вас нужный товар
            с&nbsp;лучшей ценой и&nbsp;сроком рассрочки*;
          </li>
          <li>
            <b>Страхование жизни и&nbsp;здоровья.</b> Выплаты при несчастном случае
            или&nbsp;болезни;
          </li>
          <li>
            <b>Страхование покупок.</b> Возмещение при&nbsp;повреждении или&nbsp;поломке важных
            покупок, а&nbsp;также юридическая помощь по&nbsp;правам покупателей;
          </li>
        </ul>
        <p>
          * Если базовый срок рассрочки* партнёра превышает 10&nbsp;месяцев, то к&nbsp;покупке
          применяется базовый срок.
        </p>
        <p>
          ** Ставка повышается в&nbsp;конце срока и&nbsp;начисляется на&nbsp;общую сумму вкладов
          в&nbsp;банке до&nbsp;1,5 млн ₽.
        </p>
        <p>
          *** По впервые открытым копилкам увеличенная базовая ставка начисляется первые 3 месяца на
          сумму свыше 1,5 млн руб., с 4-го месяца и по повторно открытым копилкам — на любую сумму.
        </p>
        <p>**** Без подписки «Халва.Десятка» 3 000 баллов.</p>
      </>
    ),
  },
  {
    question: "Сколько времени рассматривают заявку на Халву?",
    answer:
      "Вы получите решение через несколько минут после того, как отправите заявку. В редких случаях на это может потребоваться 1 рабочий день.",
  },
]

export const QUESTIONS_FOR_HALVA_PKW = [
  {
    question: "Халва – кредитная или дебетовая карта?",
    answer:
      "Халва – универсальная карта, которую можно использовать одновременно как дебетовую и карту рассрочки*. Сменить режим можно легко в приложении «Халва – Совкомбанк». ",
  },
  {
    question: "Какой минимальный и максимальный лимит рассрочки*?",
    answer:
      "Минимальный лимит по карте «Халва» — 15 000 руб. Максимальный лимит составляет 500 000 руб.",
  },
  {
    question: "Влияет ли наличие карты на кредитную нагрузку?",
    answer:
      "Поскольку с помощью Халвы вы покупаете товары в рассрочку*, наличие задолженности по карте влияет на кредитную нагрузку. Банк будет относиться к вам более лояльно, если вы будете активно пользоваться картой и своевременно вносить платежи.  ",
  },
  {
    question: "Насколько надежен банк, который выпускает карту? Где о нем можно узнать информацию?",
    answer: (
      <>
        Халва — это проект Совкомбанка. Вся информация о его надежности — лицензии, реквизиты,
        рейтинги финансовой организации — собрана на{" "}
        <AppLink
          rel="nofollow noopener noreferrer"
          target="_blank"
          href="https://scb.ru/about/info"
        >
          отдельной странице
        </AppLink>
        .<br />
        <br /> Совкомбанк зарекомендовал себя как надежная организация и не раз лидировал в народных
        рейтингах:{" "}
        <ul>
          <li>
            в 2018 году «Халву»{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://finelita.ru/novosti/obyavleny-laureaty-xiv-premii-finansovaya-elita-rossii-2018.html"
            >
              признали
            </AppLink>{" "}
            лучшей банковской картой года, лауреат премии «Финансовая элита России»;
          </li>
          <li>
            по итогам 2024 года банк{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://www.banki.ru/services/responses/?date=2024"
            >
              возглавил
            </AppLink>{" "}
            «Народный рейтинг» портала «
            <AppLink rel="nofollow noopener noreferrer" target="_blank" href="http://banki.ru">
              Банки.ру
            </AppLink>
            », а до 2022{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://scb.ru/articles/novosti-kompanii/sovkombank-priznan-pobeditelem-narodnogo-reitinga-banki-ru-po-itogam-2022-goda"
            >
              занимал
            </AppLink>{" "}
            в нем первое место четыре года подряд;
          </li>
          <li>
            в 2024 году Совкомбанк первый в{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://www.sravni.ru/banki/rating/karty/"
            >
              рейтинге
            </AppLink>{" "}
            кредитных карт России по версии «
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://www.sravni.ru"
            >
              Сравни»
            </AppLink>{" "}
            (⭑4.91/5.00).
          </li>
        </ul>
      </>
    ),
  },
  {
    question: "Что такое подписка «Халва.Десятка»?",
    answer: (
      <>
        Это платная услуга, с&nbsp;которой вы получаете дополнительные преимущества:
        <ul>
          <li>
            <b>10 месяцев рассрочки на&nbsp;покупки.*</b> Единый увеличенный срок рассрочки*
            в&nbsp;260&nbsp;000{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://halvacard.ru/shops/special"
            >
              магазинах-партнёрах
            </AppLink>{" "}
            Халвы*;
          </li>
          <li>
            <b>
              Удвоение{" "}
              <AppLink
                rel="nofollow noopener noreferrer"
                target="_blank"
                href="https://scb.ru/document?id=2777"
              >
                кешбэка
              </AppLink>
              .
            </b>{" "}
            В 2 раза больше кешбэка за&nbsp;каждую покупку или поездку на Яндекс GO – возвращайте
            до&nbsp;10% от&nbsp;стоимости;
          </li>
          <li>
            <b>Увеличенный лимит кешбэка в&nbsp;месяц&nbsp;5&nbsp;000.</b> Получайте больше кешбэка
            по&nbsp;карте*****;
          </li>
          <li>
            <b>+5% к&nbsp;ставке вкладов.</b> Увеличение** на&nbsp;+5% по&nbsp;вкладам на&nbsp;сроке
            36&nbsp;мес., +2% на&nbsp;сроке 24 мес. (+1% на&nbsp;других сроках) при ежемесячном
            выполнении условия: от&nbsp;10 покупок по&nbsp;Халве на&nbsp;общую сумму
            от&nbsp;20&nbsp;000&nbsp;₽.***;
          </li>
          <li>
            <b>+1% к ставке Онлайн-копилки.</b> Увеличение базовой ставки***;
          </li>
          <li>
            <b>+1 месяц рассрочки*.</b> На снятия, переводы и&nbsp;покупки заёмными средствами
            не&nbsp;у&nbsp;партнеров;
          </li>
          <li>
            <b>Бесплатный стикер Рау.</b> Для удобной оплаты телефоном и&nbsp;повышенного кешбэка;
          </li>
          <li>
            <b>Комплексная IT-защита.</b> Онлайн-консультация эксперта при неисправностях и сбоях в
            работе компьютера или смартфона;
          </li>
          <li>
            <b>Помощник по&nbsp;покупкам.</b> Личный консультант подберет для вас нужный товар
            с&nbsp;лучшей ценой и&nbsp;сроком рассрочки*;
          </li>
          <li>
            <b>Страхование жизни и&nbsp;здоровья.</b> Выплаты при несчастном случае
            или&nbsp;болезни;
          </li>
          <li>
            <b>Страхование покупок.</b> Возмещение при&nbsp;повреждении или&nbsp;поломке важных
            покупок, а&nbsp;также юридическая помощь по&nbsp;правам покупателей;
          </li>
        </ul>
        <p>
          * Если базовый срок рассрочки* партнёра превышает 10&nbsp;месяцев, то к&nbsp;покупке
          применяется базовый срок.
        </p>
        <p>
          ** Ставка повышается в&nbsp;конце срока и&nbsp;начисляется на&nbsp;общую сумму вкладов
          в&nbsp;банке до&nbsp;1,5 млн ₽.
        </p>
        <p>
          *** По впервые открытым копилкам увеличенная базовая ставка начисляется первые 3 месяца на
          сумму свыше 1,5 млн руб., с 4-го месяца и по повторно открытым копилкам — на любую сумму.
        </p>
        <p>**** Без подписки «Халва.Десятка» 3 000 баллов.</p>
      </>
    ),
  },
  {
    question: "Сколько времени рассматривают заявку на Халву?",
    answer:
      "Вы получите решение через несколько минут после того, как отправите заявку. В редких случаях на это может потребоваться 1 рабочий день.",
  },
]

export const QUESTIONS_FOR_HALVA_S_KEHSHBEHKOM = [
  {
    question: "Халва – кредитная или дебетовая карта?",
    answer:
      "Халва – универсальная карта, которую можно использовать одновременно как дебетовую и карту рассрочки*. Сменить режим можно легко в приложении «Халва – Совкомбанк». ",
  },
  {
    question: "Какой минимальный и максимальный лимит рассрочки*?",
    answer:
      "Минимальный лимит по карте «Халва» — 15 000 руб. Максимальный лимит составляет 500 000 руб.",
  },
  {
    question: "Влияет ли наличие карты на кредитную нагрузку?",
    answer:
      "Поскольку с помощью Халвы вы покупаете товары в рассрочку*, наличие задолженности по карте влияет на кредитную нагрузку. Банк будет относиться к вам более лояльно, если вы будете активно пользоваться картой и своевременно вносить платежи.  ",
  },
  {
    question: "Насколько надежен банк, который выпускает карту? Где о нем можно узнать информацию?",
    answer: (
      <>
        Халва — это проект Совкомбанка. Вся информация о его надежности — лицензии, реквизиты,
        рейтинги финансовой организации — собрана на{" "}
        <AppLink
          rel="nofollow noopener noreferrer"
          target="_blank"
          href="https://scb.ru/about/info"
        >
          отдельной странице
        </AppLink>
        .<br />
        <br /> Совкомбанк зарекомендовал себя как надежная организация и не раз лидировал в народных
        рейтингах:{" "}
        <ul>
          <li>
            в 2018 году «Халву»{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://finelita.ru/novosti/obyavleny-laureaty-xiv-premii-finansovaya-elita-rossii-2018.html"
            >
              признали
            </AppLink>{" "}
            лучшей банковской картой года, лауреат премии «Финансовая элита России»;
          </li>
          <li>
            по итогам 2024 года банк{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://www.banki.ru/services/responses/?date=2024"
            >
              возглавил
            </AppLink>{" "}
            «Народный рейтинг» портала «
            <AppLink rel="nofollow noopener noreferrer" target="_blank" href="http://banki.ru">
              Банки.ру
            </AppLink>
            », а до 2022{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://scb.ru/articles/novosti-kompanii/sovkombank-priznan-pobeditelem-narodnogo-reitinga-banki-ru-po-itogam-2022-goda"
            >
              занимал
            </AppLink>{" "}
            в нем первое место четыре года подряд;
          </li>
          <li>
            в 2024 году Совкомбанк первый в{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://www.sravni.ru/banki/rating/karty/"
            >
              рейтинге
            </AppLink>{" "}
            кредитных карт России по версии «
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://www.sravni.ru"
            >
              Сравни»
            </AppLink>{" "}
            (⭑4.91/5.00).
          </li>
        </ul>
      </>
    ),
  },
  {
    question: "Что такое подписка «Халва.Десятка»?",
    answer: (
      <>
        Это платная услуга, с&nbsp;которой вы получаете дополнительные преимущества:
        <ul>
          <li>
            <b>10 месяцев рассрочки на&nbsp;покупки.*</b> Единый увеличенный срок рассрочки*
            в&nbsp;260&nbsp;000{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://halvacard.ru/shops/special"
            >
              магазинах-партнёрах
            </AppLink>{" "}
            Халвы*;
          </li>
          <li>
            <b>
              Удвоение{" "}
              <AppLink
                rel="nofollow noopener noreferrer"
                target="_blank"
                href="https://scb.ru/document?id=2777"
              >
                кэшбэка
              </AppLink>
              .
            </b>{" "}
            В 2 раза больше кэшбэка за&nbsp;каждую покупку или поездку на Яндекс GO – возвращайте
            до&nbsp;10% от&nbsp;стоимости;
          </li>
          <li>
            <b>Увеличенный лимит кешбэка в&nbsp;месяц&nbsp;5&nbsp;000.</b> Получайте больше кешбэка
            по&nbsp;карте*****;
          </li>
          <li>
            <b>+5% к&nbsp;ставке вкладов.</b> Увеличение** на&nbsp;+5% по&nbsp;вкладам на&nbsp;сроке
            36&nbsp;мес., +2% на&nbsp;сроке 24 мес. (+1% на&nbsp;других сроках) при ежемесячном
            выполнении условия: от&nbsp;10 покупок по&nbsp;Халве на&nbsp;общую сумму
            от&nbsp;20&nbsp;000&nbsp;₽.***;
          </li>
          <li>
            <b>+1% к ставке Онлайн-копилки.</b> Увеличение базовой ставки***;
          </li>
          <li>
            <b>+1 месяц рассрочки*.</b> На снятия, переводы и&nbsp;покупки заёмными средствами
            не&nbsp;у&nbsp;партнеров;
          </li>
          <li>
            <b>Бесплатный стикер Рау.</b> Для удобной оплаты телефоном и&nbsp;повышенного кэшбэка;
          </li>
          <li>
            <b>Комплексная IT-защита.</b> Онлайн-консультация эксперта при неисправностях и сбоях в
            работе компьютера или смартфона;
          </li>
          <li>
            <b>Помощник по&nbsp;покупкам.</b> Личный консультант подберет для вас нужный товар
            с&nbsp;лучшей ценой и&nbsp;сроком рассрочки*;
          </li>
          <li>
            <b>Страхование жизни и&nbsp;здоровья.</b> Выплаты при несчастном случае
            или&nbsp;болезни;
          </li>
          <li>
            <b>Страхование покупок.</b> Возмещение при&nbsp;повреждении или&nbsp;поломке важных
            покупок, а&nbsp;также юридическая помощь по&nbsp;правам покупателей;
          </li>
        </ul>
        <p>
          * Если базовый срок рассрочки* партнёра превышает 10&nbsp;месяцев, то к&nbsp;покупке
          применяется базовый срок.
        </p>
        <p>
          ** Ставка повышается в&nbsp;конце срока и&nbsp;начисляется на&nbsp;общую сумму вкладов
          в&nbsp;банке до&nbsp;1,5 млн ₽.
        </p>
        <p>
          *** По впервые открытым копилкам увеличенная базовая ставка начисляется первые 3 месяца на
          сумму свыше 1,5 млн руб., с 4-го месяца и по повторно открытым копилкам — на любую сумму.
        </p>
        <p>**** Без подписки «Халва.Десятка» 3 000 баллов.</p>
      </>
    ),
  },
  {
    question: "Сколько времени рассматривают заявку на Халву?",
    answer:
      "Вы получите решение через несколько минут после того, как отправите заявку. В редких случаях на это может потребоваться 1 рабочий день.",
  },
]

export const QUESTIONS_FOR_HALVA_OZON = [
  {
    question: "Халва – кредитная или дебетовая карта?",
    answer:
      "Халва – универсальная карта, которую можно использовать одновременно как дебетовую и карту рассрочки*. Сменить режим можно легко в приложении «Халва – Совкомбанк». ",
  },
  {
    question: "Какой минимальный и максимальный лимит рассрочки*?",
    answer:
      "Минимальный лимит по карте «Халва» — 15 000 руб. Максимальный лимит составляет 500 000 руб.",
  },
  {
    question: "Влияет ли наличие карты на кредитную нагрузку?",
    answer:
      "Поскольку с помощью Халвы вы покупаете товары в рассрочку*, наличие задолженности по карте влияет на кредитную нагрузку. Банк будет относиться к вам более лояльно, если вы будете активно пользоваться картой и своевременно вносить платежи.  ",
  },
  {
    question: "Насколько надежен банк, который выпускает карту? Где о нем можно узнать информацию?",
    answer: (
      <>
        Халва — это проект Совкомбанка. Вся информация о его надежности — лицензии, реквизиты,
        рейтинги финансовой организации — собрана на{" "}
        <AppLink
          rel="nofollow noopener noreferrer"
          target="_blank"
          href="https://scb.ru/about/info"
        >
          отдельной странице
        </AppLink>
        .<br />
        <br /> Совкомбанк зарекомендовал себя как надежная организация и не раз лидировал в народных
        рейтингах:{" "}
        <ul>
          <li>
            в 2018 году «Халву»{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://finelita.ru/novosti/obyavleny-laureaty-xiv-premii-finansovaya-elita-rossii-2018.html"
            >
              признали
            </AppLink>{" "}
            лучшей банковской картой года, лауреат премии «Финансовая элита России»;
          </li>
          <li>
            по итогам 2024 года банк{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://www.banki.ru/services/responses/?date=2024"
            >
              возглавил
            </AppLink>{" "}
            «Народный рейтинг» портала «
            <AppLink rel="nofollow noopener noreferrer" target="_blank" href="http://banki.ru">
              Банки.ру
            </AppLink>
            », а до 2022{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://scb.ru/articles/novosti-kompanii/sovkombank-priznan-pobeditelem-narodnogo-reitinga-banki-ru-po-itogam-2022-goda"
            >
              занимал
            </AppLink>{" "}
            в нем первое место четыре года подряд;
          </li>
          <li>
            в 2024 году Совкомбанк первый в{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://www.sravni.ru/banki/rating/karty/"
            >
              рейтинге
            </AppLink>{" "}
            кредитных карт России по версии «
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://www.sravni.ru"
            >
              Сравни»
            </AppLink>{" "}
            (⭑4.91/5.00).
          </li>
        </ul>
      </>
    ),
  },
  {
    question: "Что такое подписка «Халва.Десятка»?",
    answer: (
      <>
        Это платная услуга, с&nbsp;которой вы получаете дополнительные преимущества:
        <ul>
          <li>
            <b>10 месяцев рассрочки на&nbsp;покупки.*</b> Единый увеличенный срок рассрочки*
            в&nbsp;260&nbsp;000{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://halvacard.ru/shops/special"
            >
              магазинах-партнёрах
            </AppLink>{" "}
            Халвы*;
          </li>
          <li>
            <b>
              Удвоение{" "}
              <AppLink
                rel="nofollow noopener noreferrer"
                target="_blank"
                href="https://scb.ru/document?id=2777"
              >
                кэшбэка
              </AppLink>
              .
            </b>{" "}
            В 2 раза больше кэшбэка за&nbsp;каждую покупку или поездку на Яндекс GO – возвращайте
            до&nbsp;10% от&nbsp;стоимости;
          </li>
          <li>
            <b>Увеличенный лимит кешбэка в&nbsp;месяц&nbsp;5&nbsp;000.</b> Получайте больше кешбэка
            по&nbsp;карте*****;
          </li>
          <li>
            <b>+5% к&nbsp;ставке вкладов.</b> Увеличение** на&nbsp;+5% по&nbsp;вкладам на&nbsp;сроке
            36&nbsp;мес., +2% на&nbsp;сроке 24 мес. (+1% на&nbsp;других сроках) при ежемесячном
            выполнении условия: от&nbsp;10 покупок по&nbsp;Халве на&nbsp;общую сумму
            от&nbsp;20&nbsp;000&nbsp;₽.***;
          </li>
          <li>
            <b>+1% к ставке Онлайн-копилки.</b> Увеличение базовой ставки***;
          </li>
          <li>
            <b>+1 месяц рассрочки*.</b> На снятия, переводы и&nbsp;покупки заёмными средствами
            не&nbsp;у&nbsp;партнеров;
          </li>
          <li>
            <b>Бесплатный стикер Рау.</b> Для удобной оплаты телефоном и&nbsp;повышенного кэшбэка;
          </li>
          <li>
            <b>Комплексная IT-защита.</b> Онлайн-консультация эксперта при неисправностях и сбоях в
            работе компьютера или смартфона;
          </li>
          <li>
            <b>Помощник по&nbsp;покупкам.</b> Личный консультант подберет для вас нужный товар
            с&nbsp;лучшей ценой и&nbsp;сроком рассрочки*;
          </li>
          <li>
            <b>Страхование жизни и&nbsp;здоровья.</b> Выплаты при несчастном случае
            или&nbsp;болезни;
          </li>
          <li>
            <b>Страхование покупок.</b> Возмещение при&nbsp;повреждении или&nbsp;поломке важных
            покупок, а&nbsp;также юридическая помощь по&nbsp;правам покупателей;
          </li>
        </ul>
        <p>
          * Если базовый срок рассрочки* партнёра превышает 10&nbsp;месяцев, то к&nbsp;покупке
          применяется базовый срок.
        </p>
        <p>
          ** Ставка повышается в&nbsp;конце срока и&nbsp;начисляется на&nbsp;общую сумму вкладов
          в&nbsp;банке до&nbsp;1,5 млн ₽.
        </p>
        <p>
          *** По впервые открытым копилкам увеличенная базовая ставка начисляется первые 3 месяца на
          сумму свыше 1,5 млн руб., с 4-го месяца и по повторно открытым копилкам — на любую сумму.
        </p>
        <p>**** Без подписки «Халва.Десятка» 3 000 баллов.</p>
      </>
    ),
  },
  {
    question: "Сколько времени рассматривают заявку на Халву?",
    answer:
      "Вы получите решение через несколько минут после того, как отправите заявку. В редких случаях на это может потребоваться 1 рабочий день.",
  },
  {
    question: "Что такое «зеленая цена» на Ozon?",
    answer: (
      <>
        Зелёная цена — это специальная сниженная стоимость товара. Она подсвечивается зелёным цветом
        в&nbsp;карточке товара / корзине в&nbsp;приложении «Ozon» и&nbsp;позволяет мгновенно
        получить скидку до&nbsp;30%. Данная скидка заменит кешбэк, который начисляться
        не&nbsp;будет.
      </>
    ),
  },
]

export const QUESTIONS_FOR_PKW_STICKER = [
  {
    question: "В каком городе я могу забрать стикер из отделения банка?",
    answer: (
      <>
        Город:
        <br />
        г. Красноярск <br />
        г. Волгоград <br />
        г. Воронеж <br />
        г. Нижний Новгород <br />
        г. Новосибирск <br />
        г. Омск <br />
        г. Москва <br />
        г. Уфа <br />
        г. Казань <br />
        г. Самара <br />
        г. Санкт-Петербург <br />
        г. Пермь <br />
        г. Екатеринбург <br />
        г. Челябинск <br />
        г. Краснодар <br />
        г. Ростов-на-Дону <br />
        г. Кемерово <br />
        г. Владивосток <br />
        г. Саратов <br />
        г. Тюмень <br />
        г. Калининград
      </>
    ),
  },
  {
    question: "Что такое платежный стикер?",
    answer:
      "Платежный стикер — это NFC-наклейка, которая крепится к задней части смартфона. С\u00A0его помощью можно совершать бесконтактные платежи: просто поднесите устройство к\u00A0терминалу, и\u00A0средства спишутся так\u00A0же, как с\u00A0обычной карты.",
  },
  {
    question: "Кто может получить платежный стикер?",
    answer:
      "Оформить стикер может любой держатель карты «Халва» от\u00A0Совкомбанка. Также взрослые клиенты банка могут заказать до\u00A03 стикеров для своих детей.",
  },
  {
    question: "Как работает стикер?",
    answer:
      "Платёжное средство прикладывают к терминалу, после чего происходит списание средств с карты, которая выпущена при оформлении наклейки.",
  },
  {
    question: "Сколько стоит стикер?",
    answer: (
      <>
        Выпуск, замена стикера к&nbsp;карте Халва - 599&nbsp;рублей. Обслуживание - 0&nbsp;рублей
        при&nbsp;наличии Подписки «Халва.Десятка» или при&nbsp;ежемесячном совершении
        от&nbsp;10&nbsp;покупок на&nbsp;общую сумму от&nbsp;20&nbsp;000&nbsp;руб. (иначе комиссия
        999&nbsp;руб единоразово). <br />
        Выпуск, замена стикера к&nbsp;продукту Халвау - 599&nbsp;рублей.
      </>
    ),
  },
  {
    question: "Как приклеить стикер?",
    answer:
      "Рекомендуем клеить наклейку на\u00A0нижнюю часть задней панели айфона, не\u00A0слишком близко к\u00A0модулю NFC.",
  },
  {
    question: "Нужно ли отключать NFC на\u00A0смартфоне?",
    answer: "Да, NFC на смартфоне нужно отключать для корректной работы.",
  },
  {
    question: "Стикер безопасен?",
    answer:
      "Поскольку стикер — это та же карта, только меньше и\u00A0удобнее, на ней надёжно защищены средства, как на\u00A0обычной карте. Личные данные не\u00A0указываются на стикере, поэтому пользоваться им безопасно. Также можно установить PIN-код для оплаты стикером, задать ограничения на\u00A0списание средств, заморозить или заблокировать карту в\u00A0случае её потери или кражи.",
  },
  {
    question: "Что делать, если потерял платёжный стикер?",
    answer:
      "Если стикер потерялся, следует его заморозить или заблокировать. Для этого в\u00A0приложении «Халва — Совкомбанк» выберите действие «Временная блокировка карты» или «Постоянная блокировка карты». Либо свяжитесь с\u00A0сотрудником банка по\u00A0телефону горячей линии: 8\u00A0(800)\u00A0100-00-06.",
  },
  {
    question: "Что делать, если стикер не\u00A0работает?",
    answer:
      "Удостоверьтесь, что вы действуете правильно. Проверьте, что чип поднесен прямо к\u00A0считывателю платёжного терминала. Уточните у продавца, где находится считыватель. Если это не\u00A0помогает, снимите чехол и\u00A0поднесите наклеенный на\u00A0него PAY к\u00A0считывателю терминала, без телефона. Так считываемый сигнал усилится. Если все равно не\u00A0получается провести оплату, вероятно, проблема с терминалом: он может не\u00A0работать или не\u00A0поддерживать бесконтактный способ оплаты.",
  },
  {
    question: "Можно ли снимать деньги через платёжный стикер?",
    answer: "Да. Стикер позволяет снимать деньги как с\u00A0обычной карты.",
  },
  {
    question: "Как пополнять стикер PAY?",
    answer:
      "Пополнять баланс можно между своими счетами в мобильном приложении «Халва — Совкомбанк» или с\u00A0помощью банкоматов с\u00A0бесконтактным способом авторизации. Ещё вы можете переводить деньги с\u00A0помощью Системы быстрых платежей и\u00A0получать переводы от родных и\u00A0знакомых точно так же, как на обычную карту.",
  },
]

export const QUESTIONS_FOR_DOBROE_COFFEE = [
  {
    question: "В чем суть проекта?",
    answer:
      "Это уникальная коллаборация Совкомбанка и проекта «Доброе кофе». За оформление каждой карты «Халва» банк перечисляет деньги проекту. На эти средства закупают кофейные автоматы и устанавливают на вокзалах, в МФЦ, поликлиниках и других общественных местах. Выручку с кофе направляют на добрые дела.",
  },
  {
    question: "Как принять участие?",
    answer:
      "Оформите Халву на этой странице. Оплачивайте картой напитки в автоматах «Доброе кофе» — все деньги пойдут на социально важные цели.",
  },
  {
    question: "Кто получит помощь?",
    answer: (
      <>
        Выручку от каждой продажи в автомате полностью направят на социально важные цели: <br />—
        помощь семьям участников СВО;
        <br />— покупку продуктов, лекарств и детских товаров нуждающимся;
        <br />— покупку экипировки, оплату тренировок и поездок на соревнования для талантливых
        спортсменов из малообеспеченных семей.
      </>
    ),
  },
  {
    question: "Халва – кредитная или дебетовая карта?",
    answer:
      "Халва – универсальная карта, которую можно использовать одновременно как дебетовую и карту рассрочки*. Сменить режим можно легко в приложении «Халва – Совкомбанк». ",
  },
  {
    question: "Какой минимальный и максимальный лимит рассрочки*?",
    answer:
      "Минимальный лимит по карте «Халва» — 15 000 руб. Максимальный лимит составляет 500 000 руб.",
  },
  {
    question: "Влияет ли наличие карты на кредитную нагрузку?",
    answer:
      "Поскольку с помощью Халвы вы покупаете товары в рассрочку*, наличие задолженности по карте влияет на кредитную нагрузку. Банк будет относиться к вам более лояльно, если вы будете активно пользоваться картой и своевременно вносить платежи.  ",
  },
  {
    question: "Насколько надежен банк, который выпускает карту? Где о нем можно узнать информацию?",
    answer: (
      <>
        Халва — это проект Совкомбанка. Вся информация о его надежности — лицензии, реквизиты,
        рейтинги финансовой организации — собрана на{" "}
        <AppLink
          rel="nofollow noopener noreferrer"
          target="_blank"
          href="https://scb.ru/about/info"
        >
          отдельной странице
        </AppLink>
        .<br />
        <br /> Совкомбанк зарекомендовал себя как надежная организация и не раз лидировал в народных
        рейтингах:{" "}
        <ul>
          <li>
            в 2018 году «Халву»{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://finelita.ru/novosti/obyavleny-laureaty-xiv-premii-finansovaya-elita-rossii-2018.html"
            >
              признали
            </AppLink>{" "}
            лучшей банковской картой года, лауреат премии «Финансовая элита России»;
          </li>
          <li>
            по итогам 2024 года банк{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://www.banki.ru/services/responses/?date=2024"
            >
              возглавил
            </AppLink>{" "}
            «Народный рейтинг» портала «
            <AppLink rel="nofollow noopener noreferrer" target="_blank" href="http://banki.ru">
              Банки.ру
            </AppLink>
            », а до 2022{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://scb.ru/articles/novosti-kompanii/sovkombank-priznan-pobeditelem-narodnogo-reitinga-banki-ru-po-itogam-2022-goda"
            >
              занимал
            </AppLink>{" "}
            в нем первое место четыре года подряд;
          </li>
          <li>
            в 2024 году Совкомбанк первый в{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://www.sravni.ru/banki/rating/karty/"
            >
              рейтинге
            </AppLink>{" "}
            кредитных карт России по версии «
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://www.sravni.ru"
            >
              Сравни»
            </AppLink>{" "}
            (⭑4.91/5.00).
          </li>
        </ul>
      </>
    ),
  },
  {
    question: "Что такое подписка «Халва.Десятка»?",
    answer: (
      <>
        Это платная услуга, с&nbsp;которой вы получаете дополнительные преимущества:
        <ul>
          <li>
            <b>10 месяцев рассрочки на&nbsp;покупки.*</b> Единый увеличенный срок рассрочки*
            в&nbsp;260&nbsp;000{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://halvacard.ru/shops/special"
            >
              магазинах-партнёрах
            </AppLink>{" "}
            Халвы*;
          </li>
          <li>
            <b>
              Удвоение{" "}
              <AppLink
                rel="nofollow noopener noreferrer"
                target="_blank"
                href="https://scb.ru/document?id=2777"
              >
                кэшбэка
              </AppLink>
              .
            </b>{" "}
            В 2 раза больше кэшбэка за&nbsp;каждую покупку или поездку на Яндекс GO – возвращайте
            до&nbsp;10% от&nbsp;стоимости;
          </li>
          <li>
            <b>Увеличенный лимит кешбэка в&nbsp;месяц&nbsp;5&nbsp;000.</b> Получайте больше кешбэка
            по&nbsp;карте*****;
          </li>
          <li>
            <b>+5% к&nbsp;ставке вкладов.</b> Увеличение** на&nbsp;+5% по&nbsp;вкладам на&nbsp;сроке
            36&nbsp;мес., +2% на&nbsp;сроке 24 мес. (+1% на&nbsp;других сроках) при ежемесячном
            выполнении условия: от&nbsp;10 покупок по&nbsp;Халве на&nbsp;общую сумму
            от&nbsp;20&nbsp;000&nbsp;₽.***;
          </li>
          <li>
            <b>+1% к ставке Онлайн-копилки.</b> Увеличение базовой ставки***;
          </li>
          <li>
            <b>+1 месяц рассрочки*.</b> На снятия, переводы и&nbsp;покупки заёмными средствами
            не&nbsp;у&nbsp;партнеров;
          </li>
          <li>
            <b>Бесплатный стикер Рау.</b> Для удобной оплаты телефоном и&nbsp;повышенного кэшбэка;
          </li>
          <li>
            <b>Комплексная IT-защита.</b> Онлайн-консультация эксперта при неисправностях и сбоях в
            работе компьютера или смартфона;
          </li>
          <li>
            <b>Помощник по&nbsp;покупкам.</b> Личный консультант подберет для вас нужный товар
            с&nbsp;лучшей ценой и&nbsp;сроком рассрочки*;
          </li>
          <li>
            <b>Страхование жизни и&nbsp;здоровья.</b> Выплаты при несчастном случае
            или&nbsp;болезни;
          </li>
          <li>
            <b>Страхование покупок.</b> Возмещение при&nbsp;повреждении или&nbsp;поломке важных
            покупок, а&nbsp;также юридическая помощь по&nbsp;правам покупателей;
          </li>
        </ul>
        <p>
          * Если базовый срок рассрочки* партнёра превышает 10&nbsp;месяцев, то к&nbsp;покупке
          применяется базовый срок.
        </p>
        <p>
          ** Ставка повышается в&nbsp;конце срока и&nbsp;начисляется на&nbsp;общую сумму вкладов
          в&nbsp;банке до&nbsp;1,5 млн ₽.
        </p>
        <p>
          *** По впервые открытым копилкам увеличенная базовая ставка начисляется первые 3 месяца на
          сумму свыше 1,5 млн руб., с 4-го месяца и по повторно открытым копилкам — на любую сумму.
        </p>
        <p>**** Без подписки «Халва.Десятка» 3 000 баллов.</p>
      </>
    ),
  },
  {
    question: "Сколько времени рассматривают заявку на Халву?",
    answer:
      "Вы получите решение через несколько минут после того, как отправите заявку. В редких случаях на это может потребоваться 1 рабочий день.",
  },
]

export const QUESTIONS_FOR_PLAIT = [
  {
    question: "Халва – кредитная или дебетовая карта?",
    answer:
      "Халва – универсальная карта, которую можно использовать одновременно как дебетовую и карту рассрочки*. Сменить режим можно легко в приложении «Халва – Совкомбанк». ",
  },
  {
    question: "Какой минимальный и максимальный лимит рассрочки*?",
    answer:
      "Минимальный лимит по карте «Халва» — 15 000 руб. Максимальный лимит составляет 500 000 руб.",
  },
  {
    question: "Влияет ли наличие карты на кредитную нагрузку?",
    answer:
      "Поскольку с помощью Халвы вы покупаете товары в рассрочку*, наличие задолженности по карте влияет на кредитную нагрузку. Банк будет относиться к вам более лояльно, если вы будете активно пользоваться картой и своевременно вносить платежи.  ",
  },
  {
    question: "Насколько надежен банк, который выпускает карту? Где о нем можно узнать информацию?",
    answer: (
      <>
        Халва — это проект Совкомбанка. Вся информация о его надежности — лицензии, реквизиты,
        рейтинги финансовой организации — собрана на{" "}
        <AppLink
          rel="nofollow noopener noreferrer"
          target="_blank"
          href="https://scb.ru/about/info"
        >
          отдельной странице
        </AppLink>
        .<br />
        <br /> Совкомбанк зарекомендовал себя как надежная организация и не раз лидировал в народных
        рейтингах:{" "}
        <ul>
          <li>
            в 2018 году «Халву»{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://finelita.ru/novosti/obyavleny-laureaty-xiv-premii-finansovaya-elita-rossii-2018.html"
            >
              признали
            </AppLink>{" "}
            лучшей банковской картой года, лауреат премии «Финансовая элита России»;
          </li>
          <li>
            по итогам 2024 года банк{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://www.banki.ru/services/responses/?date=2024"
            >
              возглавил
            </AppLink>{" "}
            «Народный рейтинг» портала «
            <AppLink rel="nofollow noopener noreferrer" target="_blank" href="http://banki.ru">
              Банки.ру
            </AppLink>
            », а до 2022{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://scb.ru/articles/novosti-kompanii/sovkombank-priznan-pobeditelem-narodnogo-reitinga-banki-ru-po-itogam-2022-goda"
            >
              занимал
            </AppLink>{" "}
            в нем первое место четыре года подряд;
          </li>
          <li>
            в 2024 году Совкомбанк первый в{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://www.sravni.ru/banki/rating/karty/"
            >
              рейтинге
            </AppLink>{" "}
            кредитных карт России по версии «
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://www.sravni.ru"
            >
              Сравни»
            </AppLink>{" "}
            (⭑4.91/5.00).
          </li>
        </ul>
      </>
    ),
  },
  {
    question: "Что такое подписка «Халва.Десятка»?",
    answer: (
      <>
        Это платная услуга, с&nbsp;которой вы получаете дополнительные преимущества:
        <ul>
          <li>
            <b>10 месяцев рассрочки на&nbsp;покупки.*</b> Единый увеличенный срок рассрочки*
            в&nbsp;260&nbsp;000{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://halvacard.ru/shops/special"
            >
              магазинах-партнёрах
            </AppLink>{" "}
            Халвы*;
          </li>
          <li>
            <b>
              Удвоение{" "}
              <AppLink
                rel="nofollow noopener noreferrer"
                target="_blank"
                href="https://scb.ru/document?id=2777"
              >
                кэшбэка
              </AppLink>
              .
            </b>{" "}
            В 2 раза больше кэшбэка за&nbsp;каждую покупку или поездку на Яндекс GO – возвращайте
            до&nbsp;10% от&nbsp;стоимости;
          </li>
          <li>
            <b>Увеличенный лимит кешбэка в&nbsp;месяц&nbsp;5&nbsp;000.</b> Получайте больше кешбэка
            по&nbsp;карте*****;
          </li>
          <li>
            <b>+5% к&nbsp;ставке вкладов.</b> Увеличение** на&nbsp;+5% по&nbsp;вкладам на&nbsp;сроке
            36&nbsp;мес., +2% на&nbsp;сроке 24 мес. (+1% на&nbsp;других сроках) при ежемесячном
            выполнении условия: от&nbsp;10 покупок по&nbsp;Халве на&nbsp;общую сумму
            от&nbsp;20&nbsp;000&nbsp;₽.***;
          </li>
          <li>
            <b>+1% к ставке Онлайн-копилки.</b> Увеличение базовой ставки***;
          </li>
          <li>
            <b>+1 месяц рассрочки*.</b> На снятия, переводы и&nbsp;покупки заёмными средствами
            не&nbsp;у&nbsp;партнеров;
          </li>
          <li>
            <b>Бесплатный стикер Рау.</b> Для удобной оплаты телефоном и&nbsp;повышенного кэшбэка;
          </li>
          <li>
            <b>Комплексная IT-защита.</b> Онлайн-консультация эксперта при неисправностях и сбоях в
            работе компьютера или смартфона;
          </li>
          <li>
            <b>Помощник по&nbsp;покупкам.</b> Личный консультант подберет для вас нужный товар
            с&nbsp;лучшей ценой и&nbsp;сроком рассрочки*;
          </li>
          <li>
            <b>Страхование жизни и&nbsp;здоровья.</b> Выплаты при несчастном случае
            или&nbsp;болезни;
          </li>
          <li>
            <b>Страхование покупок.</b> Возмещение при&nbsp;повреждении или&nbsp;поломке важных
            покупок, а&nbsp;также юридическая помощь по&nbsp;правам покупателей;
          </li>
        </ul>
        <p>
          * Если базовый срок рассрочки* партнёра превышает 10&nbsp;месяцев, то к&nbsp;покупке
          применяется базовый срок.
        </p>
        <p>
          ** Ставка повышается в&nbsp;конце срока и&nbsp;начисляется на&nbsp;общую сумму вкладов
          в&nbsp;банке до&nbsp;1,5 млн ₽.
        </p>
        <p>
          *** По впервые открытым копилкам увеличенная базовая ставка начисляется первые 3 месяца на
          сумму свыше 1,5 млн руб., с 4-го месяца и по повторно открытым копилкам — на любую сумму.
        </p>
        <p>**** Без подписки «Халва.Десятка» 3 000 баллов.</p>
      </>
    ),
  },
  {
    question: "Сколько времени рассматривают заявку на Халву?",
    answer:
      "Вы получите решение через несколько минут после того, как отправите заявку. В редких случаях на это может потребоваться 1 рабочий день.",
  },
]

export const QUESTIONS_FOR_HALVA_MEDIA = [
  {
    question: "Халва – кредитная или дебетовая карта?",
    answer:
      "Халва – универсальная карта, которую можно использовать одновременно как дебетовую и карту рассрочки*. Сменить режим можно легко в приложении «Халва – Совкомбанк». ",
  },
  {
    question: "Какой минимальный и максимальный лимит рассрочки*?",
    answer:
      "Минимальный лимит по карте «Халва» — 15 000 руб. Максимальный лимит составляет 500 000 руб.",
  },
  {
    question: "Влияет ли наличие карты на кредитную нагрузку?",
    answer:
      "Поскольку с помощью Халвы вы покупаете товары в рассрочку*, наличие задолженности по карте влияет на кредитную нагрузку. Банк будет относиться к вам более лояльно, если вы будете активно пользоваться картой и своевременно вносить платежи.  ",
  },
  {
    question: "Насколько надежен банк, который выпускает карту? Где о нем можно узнать информацию?",
    answer: (
      <>
        Халва — это проект Совкомбанка. Вся информация о его надежности — лицензии, реквизиты,
        рейтинги финансовой организации — собрана на{" "}
        <AppLink
          rel="nofollow noopener noreferrer"
          target="_blank"
          href="https://scb.ru/about/info"
        >
          отдельной странице
        </AppLink>
        .<br />
        <br /> Совкомбанк зарекомендовал себя как надежная организация и не раз лидировал в народных
        рейтингах:{" "}
        <ul>
          <li>
            в 2018 году «Халву»{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://finelita.ru/novosti/obyavleny-laureaty-xiv-premii-finansovaya-elita-rossii-2018.html"
            >
              признали
            </AppLink>{" "}
            лучшей банковской картой года, лауреат премии «Финансовая элита России»;
          </li>
          <li>
            по итогам 2024 года банк{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://www.banki.ru/services/responses/?date=2024"
            >
              возглавил
            </AppLink>{" "}
            «Народный рейтинг» портала «
            <AppLink rel="nofollow noopener noreferrer" target="_blank" href="http://banki.ru">
              Банки.ру
            </AppLink>
            », а до 2022{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://scb.ru/articles/novosti-kompanii/sovkombank-priznan-pobeditelem-narodnogo-reitinga-banki-ru-po-itogam-2022-goda"
            >
              занимал
            </AppLink>{" "}
            в нем первое место четыре года подряд;
          </li>
          <li>
            в 2024 году Совкомбанк первый в{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://www.sravni.ru/banki/rating/karty/"
            >
              рейтинге
            </AppLink>{" "}
            кредитных карт России по версии «
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://www.sravni.ru"
            >
              Сравни»
            </AppLink>{" "}
            (⭑4.91/5.00).
          </li>
        </ul>
      </>
    ),
  },
  {
    question: "Что такое подписка «Халва.Десятка»?",
    answer: (
      <>
        Это платная услуга, с&nbsp;которой вы получаете дополнительные преимущества:
        <ul>
          <li>
            <b>10 месяцев рассрочки на&nbsp;покупки.*</b> Единый увеличенный срок рассрочки*
            в&nbsp;260&nbsp;000{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://halvacard.ru/shops/special"
            >
              магазинах-партнёрах
            </AppLink>{" "}
            Халвы*;
          </li>
          <li>
            <b>
              Удвоение{" "}
              <AppLink
                rel="nofollow noopener noreferrer"
                target="_blank"
                href="https://scb.ru/document?id=2777"
              >
                кэшбэка
              </AppLink>
              .
            </b>{" "}
            В 2 раза больше кэшбэка за&nbsp;каждую покупку или поездку на Яндекс GO – возвращайте
            до&nbsp;10% от&nbsp;стоимости;
          </li>
          <li>
            <b>Увеличенный лимит кешбэка в&nbsp;месяц&nbsp;5&nbsp;000.</b> Получайте больше кешбэка
            по&nbsp;карте*****;
          </li>
          <li>
            <b>+5% к&nbsp;ставке вкладов.</b> Увеличение** на&nbsp;+5% по&nbsp;вкладам на&nbsp;сроке
            36&nbsp;мес., +2% на&nbsp;сроке 24 мес. (+1% на&nbsp;других сроках) при ежемесячном
            выполнении условия: от&nbsp;10 покупок по&nbsp;Халве на&nbsp;общую сумму
            от&nbsp;20&nbsp;000&nbsp;₽.***;
          </li>
          <li>
            <b>+1% к ставке Онлайн-копилки.</b> Увеличение базовой ставки***;
          </li>
          <li>
            <b>+1 месяц рассрочки*.</b> На снятия, переводы и&nbsp;покупки заёмными средствами
            не&nbsp;у&nbsp;партнеров;
          </li>
          <li>
            <b>Бесплатный стикер Рау.</b> Для удобной оплаты телефоном и&nbsp;повышенного кэшбэка;
          </li>
          <li>
            <b>Комплексная IT-защита.</b> Онлайн-консультация эксперта при неисправностях и сбоях в
            работе компьютера или смартфона;
          </li>
          <li>
            <b>Помощник по&nbsp;покупкам.</b> Личный консультант подберет для вас нужный товар
            с&nbsp;лучшей ценой и&nbsp;сроком рассрочки*;
          </li>
          <li>
            <b>Страхование жизни и&nbsp;здоровья.</b> Выплаты при несчастном случае
            или&nbsp;болезни;
          </li>
          <li>
            <b>Страхование покупок.</b> Возмещение при&nbsp;повреждении или&nbsp;поломке важных
            покупок, а&nbsp;также юридическая помощь по&nbsp;правам покупателей;
          </li>
        </ul>
        <p>
          * Если базовый срок рассрочки* партнёра превышает 10&nbsp;месяцев, то к&nbsp;покупке
          применяется базовый срок.
        </p>
        <p>
          ** Ставка повышается в&nbsp;конце срока и&nbsp;начисляется на&nbsp;общую сумму вкладов
          в&nbsp;банке до&nbsp;1,5 млн ₽.
        </p>
        <p>
          *** По впервые открытым копилкам увеличенная базовая ставка начисляется первые 3 месяца на
          сумму свыше 1,5 млн руб., с 4-го месяца и по повторно открытым копилкам — на любую сумму.
        </p>
        <p>**** Без подписки «Халва.Десятка» 3 000 баллов.</p>
      </>
    ),
  },
  {
    question: "Сколько времени рассматривают заявку на Халву?",
    answer:
      "Вы получите решение через несколько минут после того, как отправите заявку. В редких случаях на это может потребоваться 1 рабочий день.",
  },
]

export const QUESTIONS_FOR_GETHALVA = [
  {
    question: "Халва – кредитная или дебетовая карта?",
    answer:
      "Халва – универсальная карта, которую можно использовать одновременно как дебетовую и карту рассрочки*. Сменить режим можно легко в приложении «Халва – Совкомбанк». ",
  },
  {
    question: "Какой у карты срок действия?",
    answer:
      "Срок действия карты Рассрочки*  Халва  7 лет. В конце срока предусмотрен автоматический перевыпуск.  Достаточно будет прийти за новой картой с паспортом в любое отделение банка.  Перевыпуск и обслуживание карты Совкомбанка полностью бесплатные.",
  },
  {
    question: "Что будет, если просрочить ежемесячный платеж?",
    answer:
      "При просрочке от одного до пяти дней никаких санкций не предусмотрено. С шестого дня просрочки будут начислять 0,1 % от суммы просроченной задолженности за каждый день нарушения обязательств.",
  },
  {
    question: "Какой минимальный и максимальный лимит рассрочки*?",
    answer:
      "На балансе Халвы может быть от 15 000 рублей заемных средств. Но количество доступных средств бывает и значительно больше. Максимум — 500 000 рублей.",
  },
  {
    question: "Есть ли платные услуги, которые подключены по умолчанию?",
    answer: "Нет, все услуги мы подключаем с согласия клиента. Они не являются обязательными.",
  },
  {
    question: "Влияет ли наличие карты на кредитную нагрузку?",
    answer:
      "Поскольку с помощью Халвы вы покупаете товары в рассрочку*, наличие задолженности по карте влияет на кредитную нагрузку. Банк будет относиться к вам более лояльно, если вы будете активно пользоваться картой и своевременно вносить платежи.  ",
  },
  {
    question: "Сколько времени рассматривают заявку на Халву?",
    answer:
      "Вы получите решение через несколько минут после того, как отправите заявку. В редких случаях на это может потребоваться 1 рабочий день.",
  },
  {
    question: "Как получить до 15,5% годовых по накопительному счету?",
    answer: (
      <>
        Чтобы получить до 15,5% по&nbsp;накопительному счету: откройте счет в&nbsp;мобильном
        приложении или&nbsp;личном кабинете на&nbsp;сайте на&nbsp;
        <AppLink rel="nofollow noopener noreferrer" target="_blank" href="https://halvacard.ru">
          halvacard.ru
        </AppLink>
        . Если вы впервые открываете «Накопительный счет», то&nbsp;на&nbsp;первые три месяца
        устанавливается повышенная ставка&nbsp;15,5%&nbsp;год. на&nbsp;сумму до&nbsp;1,5 млн руб.,
        на&nbsp;сумму свыше&nbsp;—&nbsp;11% с&nbsp;подпиской и&nbsp;10% без&nbsp;подписки;
        с&nbsp;4-го месяца 11%&nbsp;год. на&nbsp;любую сумму при наличии карты «Халва»
        с&nbsp;подпиской «Халва.Десятка», без&nbsp;подписки&nbsp;—&nbsp;10%. При закрытии
        до&nbsp;завершения отчетного месяца&nbsp;—&nbsp;ставка&nbsp;0&nbsp;% год за&nbsp;неполный
        месяц. Пополнение без ограничений.
      </>
    ),
  },
]

export const QUESTIONS_FOR_INVITE_FRIEND = [
  {
    question: "Как оформить Халву и сколько это стоит?",
    answer: (
      <>
        Оставьте онлайн-заявку на&nbsp;карту и&nbsp;дождитесь решения. Оформляем и&nbsp;выпускаем
        бесплатно
      </>
    ),
  },
  {
    question: "Как получить карту?",
    answer: <>Доставим бесплатно или&nbsp;заберите сами в&nbsp;банке — как вам удобно</>,
  },
  {
    question: "Мне отправили ссылку на&nbsp;оформление карты «Халва». Как&nbsp;получить бонусы?",
    answer: (
      <>
        Чтобы получить баллы, соблюдайте 2 важных условия:
        <ol>
          <li>Переходите на страницу карты строго по ссылке друга</li>
          <li>
            Воспользуйтесь ссылкой и оформите продукт не позднее 10 дней после получения ссылки
          </li>
        </ol>
      </>
    ),
  },
  {
    question: "Сколько баллов я получу за&nbsp;оформление Халвы?",
    answer:
      "1 000 баллов — если использовали заёмные средства, 500 баллов — если оплатили покупки полностью или частично своими деньгами",
  },
  {
    question: "Что делать с начисленными баллами?",
    answer:
      "Вы можете их использовать, чтобы заплатить за такси, кофе, продукты и любые другие покупки: просто выберите оплату баллами в приложении «Халва-Совкомбанк»",
  },
  {
    question: "Какие условия мне нужно выполнить, чтобы начислили баллы?",
    answer: (
      <>
        Баллы автоматически поступят на счёт, если выполнили эти условия:
        <ol>
          <li>Перешли по ссылке друга и&nbsp;заполнили заявку на&nbsp;карту.</li>
          <li>Получили карту в&nbsp;офисе банка или&nbsp;доставкой в&nbsp;течение 10 дней.</li>
          <li>
            Сделали покупки от 1 000 ₽ в магазинах-партнёрах Халвы не позднее 10 дней после
            получения карты
          </li>
        </ol>
      </>
    ),
  },
  {
    question: "Когда зачислят баллы?",
    answer: "Не позднее 50 дней после выполнения всех условий",
  },
]

export const QUESTIONS_FOR_RASSROCHKA_NA_AUTO = [
  {
    question: "Халва – кредитная или дебетовая карта?",
    answer:
      "Халва – универсальная карта, которую можно использовать одновременно как дебетовую и карту рассрочки*. Сменить режим можно легко в приложении «Халва – Совкомбанк». ",
  },
  {
    question: "Какой у карты срок действия?",
    answer:
      "Срок действия карты Рассрочки*  Халва  7 лет. В конце срока предусмотрен автоматический перевыпуск.  Достаточно будет прийти за новой картой с паспортом в любое отделение банка.  Перевыпуск и обслуживание карты Совкомбанка полностью бесплатные.",
  },
  {
    question: "Что будет, если просрочить ежемесячный платеж?",
    answer:
      "При просрочке от одного до пяти дней никаких санкций не предусмотрено. С шестого дня просрочки будут начислять 0,1 % от суммы просроченной задолженности за каждый день нарушения обязательств.",
  },
  {
    question: "Какой минимальный и максимальный лимит рассрочки*?",
    answer:
      "На балансе Халвы может быть от 15 000 рублей заемных средств. Но количество доступных средств бывает и значительно больше. Максимум — 500 000 рублей.",
  },
  {
    question: "Есть ли платные услуги, которые подключены по умолчанию?",
    answer: "Нет, все услуги мы подключаем с согласия клиента. Они не являются обязательными.",
  },
  {
    question: "Влияет ли наличие карты на кредитную нагрузку?",
    answer:
      "Поскольку с помощью Халвы вы покупаете товары в рассрочку*, наличие задолженности по карте влияет на кредитную нагрузку. Банк будет относиться к вам более лояльно, если вы будете активно пользоваться картой и своевременно вносить платежи.  ",
  },
  {
    question: "Буду ли я получать уведомления об операциях по карте? Сколько это стоит?",
    answer: (
      <>
        По всем операциям на вашей карте будут поступать уведомления. Для этого включите
        push-уведомления в приложении. <br /> <br /> Помимо этого, вы можете получать
        СМС-оповещения. Они будут бесплатными, если вы будете соблюдать два простых условия:
        заходить в приложение банка или личный кабинет на сайте Халвы не менее трех раз в месяц и не
        отключать push-уведомления в приложении. В ином случае СМС-оповещение станет платным и
        составит 99 рублей. <br /> <br /> Для клиентов банка старше 50 лет и тех, кто получил, но
        еще не воспользовался картой, СМС-уведомления бесплатные.
      </>
    ),
  },
  {
    question: "Насколько надежен банк, который выпускает карту? Где о нем можно узнать информацию?",
    answer: (
      <>
        Халва — это проект Совкомбанка. Вся информация о его надежности — лицензии, реквизиты,
        рейтинги финансовой организации — собрана на{" "}
        <AppLink
          rel="nofollow noopener noreferrer"
          target="_blank"
          href="https://scb.ru/about/info"
        >
          отдельной странице
        </AppLink>
        .<br />
        <br /> Совкомбанк зарекомендовал себя как надежная организация и не раз лидировал в народных
        рейтингах:{" "}
        <ul>
          <li>
            в 2018 году «Халву»{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://finelita.ru/novosti/obyavleny-laureaty-xiv-premii-finansovaya-elita-rossii-2018.html"
            >
              признали
            </AppLink>{" "}
            лучшей банковской картой года, лауреат премии «Финансовая элита России»;
          </li>
          <li>
            по итогам 2024 года банк{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://www.banki.ru/services/responses/?date=2024"
            >
              возглавил
            </AppLink>{" "}
            «Народный рейтинг» портала «
            <AppLink rel="nofollow noopener noreferrer" target="_blank" href="http://banki.ru">
              Банки.ру
            </AppLink>
            », а до 2022{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://scb.ru/articles/novosti-kompanii/sovkombank-priznan-pobeditelem-narodnogo-reitinga-banki-ru-po-itogam-2022-goda"
            >
              занимал
            </AppLink>{" "}
            в нем первое место четыре года подряд;
          </li>
          <li>
            в 2024 году Совкомбанк первый в{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://www.sravni.ru/banki/rating/karty/"
            >
              рейтинге
            </AppLink>{" "}
            кредитных карт России по версии «
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://www.sravni.ru"
            >
              Сравни»
            </AppLink>{" "}
            (⭑4.91/5.00).
          </li>
        </ul>
      </>
    ),
  },
  {
    question: "Что такое подписка «Халва.Десятка»?",
    answer: (
      <>
        Это платная услуга, с&nbsp;которой вы получаете дополнительные преимущества:
        <ul>
          <li>
            <b>10 месяцев рассрочки на&nbsp;покупки.*</b> Единый увеличенный срок рассрочки*
            в&nbsp;260&nbsp;000{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://halvacard.ru/shops/special"
            >
              магазинах-партнёрах
            </AppLink>{" "}
            Халвы*;
          </li>
          <li>
            <b>
              Удвоение{" "}
              <AppLink
                rel="nofollow noopener noreferrer"
                target="_blank"
                href="https://scb.ru/document?id=2777"
              >
                кэшбэка
              </AppLink>
              .
            </b>{" "}
            В 2 раза больше кэшбэка за&nbsp;каждую покупку или поездку на Яндекс GO – возвращайте
            до&nbsp;10% от&nbsp;стоимости;
          </li>
          <li>
            <b>Увеличенный лимит кешбэка в&nbsp;месяц&nbsp;5&nbsp;000.</b> Получайте больше кешбэка
            по&nbsp;карте*****;
          </li>
          <li>
            <b>+5% к&nbsp;ставке вкладов.</b> Увеличение** на&nbsp;+5% по&nbsp;вкладам на&nbsp;сроке
            36&nbsp;мес., +2% на&nbsp;сроке 24 мес. (+1% на&nbsp;других сроках) при ежемесячном
            выполнении условия: от&nbsp;10 покупок по&nbsp;Халве на&nbsp;общую сумму
            от&nbsp;20&nbsp;000&nbsp;₽.***;
          </li>
          <li>
            <b>+1% к ставке Онлайн-копилки.</b> Увеличение базовой ставки***;
          </li>
          <li>
            <b>+1 месяц рассрочки*.</b> На снятия, переводы и&nbsp;покупки заёмными средствами
            не&nbsp;у&nbsp;партнеров;
          </li>
          <li>
            <b>Бесплатный стикер Рау.</b> Для удобной оплаты телефоном и&nbsp;повышенного кэшбэка;
          </li>
          <li>
            <b>Комплексная IT-защита.</b> Онлайн-консультация эксперта при неисправностях и сбоях в
            работе компьютера или смартфона;
          </li>
          <li>
            <b>Помощник по&nbsp;покупкам.</b> Личный консультант подберет для вас нужный товар
            с&nbsp;лучшей ценой и&nbsp;сроком рассрочки*;
          </li>
          <li>
            <b>Страхование жизни и&nbsp;здоровья.</b> Выплаты при несчастном случае
            или&nbsp;болезни;
          </li>
          <li>
            <b>Страхование покупок.</b> Возмещение при&nbsp;повреждении или&nbsp;поломке важных
            покупок, а&nbsp;также юридическая помощь по&nbsp;правам покупателей;
          </li>
        </ul>
        <p>
          * Если базовый срок рассрочки* партнёра превышает 10&nbsp;месяцев, то к&nbsp;покупке
          применяется базовый срок.
        </p>
        <p>
          ** Ставка повышается в&nbsp;конце срока и&nbsp;начисляется на&nbsp;общую сумму вкладов
          в&nbsp;банке до&nbsp;1,5 млн ₽.
        </p>
        <p>
          *** По впервые открытым копилкам увеличенная базовая ставка начисляется первые 3 месяца на
          сумму свыше 1,5 млн руб., с 4-го месяца и по повторно открытым копилкам — на любую сумму.
        </p>
        <p>**** Без подписки «Халва.Десятка» 3 000 баллов.</p>
      </>
    ),
  },
  {
    question: "Сколько времени рассматривают заявку на Халву?",
    answer:
      "Вы получите решение через несколько минут после того, как отправите заявку. В редких случаях на это может потребоваться 1 рабочий день.",
  },
  {
    question: "Как оформить автомобиль в рассрочку* с Халвой?",
    answer: (
      <>
        <ol>
          <li>1. Выбрать у дилера автомобиль, который подпадает под условия авторассрочки*</li>
          <li>2. Заполнить с дилером заявку на авторассрочку* и получить одобрение от банка</li>
          <li>3. Подписать кредитный договор, забрать у дилера карту Халва и Автомобиль</li>
          <li>
            4. А дальше — получать удовольствие от своего автомобиля и постепенно выплачивать его
            стоимость банку
          </li>
        </ol>
      </>
    ),
  },
]

export const QUESTIONS_FOR_IRBIS = [
  {
    question: "Халва – кредитная или дебетовая карта?",
    answer:
      "Халва – универсальная карта, которую можно использовать одновременно как дебетовую и карту рассрочки*. Сменить режим можно легко в приложении «Халва – Совкомбанк». ",
  },
  {
    question: "Какой минимальный и максимальный лимит рассрочки*?",
    answer:
      "Минимальный лимит по карте «Халва» — 15 000 руб. Максимальный лимит составляет 500 000 руб.",
  },
  {
    question: "Как участвовать в акции розыгрыш тонны бензина и кэшбэка?",
    answer:
      "Активируйте акцию в разделе «Акции и скидки», совершите 2 покупки по карте Халва в сети АЗС Irbis от 1500 рублей, дождитесь результатов розыгрыша. Больше покупок – больше шансов.",
  },
  {
    question: "Где ознакомиться с полными Правилами Акции?",
    answer: (
      <>
        Полные Правила Акции можно прочитать по ссылке{" "}
        <AppLink rel="nofollow noopener noreferrer" target="_blank" href="https://halvacard.ru/">
          Halvacard.ru
        </AppLink>
      </>
    ),
  },
  {
    question: "Какие АЗС участвуют в акции?",
    answer: "С полным списком АЗС Irbis, участвующих в акции, можно ознакомиться в Паспорте Акции",
  },
  {
    question: "Где можно ознакомится с результатами розыгрыша?",
    answer: "Результаты розыгрыша буду опубликованы на сайте Halvacard.ru до 00.00.0000.",
  },
  {
    question: "Сколько времени рассматривают заявку на Халву?",
    answer:
      "Вы получите решение через несколько минут после того, как отправите заявку. В редких случаях на это может потребоваться 1 рабочий день.",
  },
]

export const QUESTIONS_FOR_PKW_CREDIT_CARDS = [
  {
    question: "Что такое «зеленая цена» на Ozon?",
    answer: (
      <>
        Зеленая цена — это специальная сниженная стоимость товара. Она подсвечивается зелёным цветом
        в&nbsp;карточке товара / корзине в&nbsp;приложении «Ozon» и&nbsp;позволяет мгновенно
        получить скидку до&nbsp;30%. Данная скидка заменит кешбэк, который начисляться
        не&nbsp;будет.
      </>
    ),
  },
  {
    question: "Какие преимущества дает подписка «Оптима»?",
    answer: (
      <>
        <p>
          Подключите подписку «Оптима» и&nbsp;за&nbsp;0&nbsp;рублей&sup1; попробуйте все её
          преимущества:
        </p>
        <br />
        <ul>
          <li>
            <b>Увеличенный льготный период до &nbsp;300 дней (до 120 дней – со второго месяца).</b>{" "}
            Делайте покупки без&nbsp;переплаты
          </li>
          <li>
            <b>
              +5% к&nbsp;
              <AppLink
                rel="nofollow noopener noreferrer"
                target="_blank"
                href="https://scb.ru/deposits/special-Increase-the-rate-by-1"
              >
                ставке вкладов
              </AppLink>
              .
            </b>{" "}
            Увеличение&sup2; на&nbsp;+5% по&nbsp;вкладам на&nbsp;36&nbsp;мес., +2%
            на&nbsp;24&nbsp;мес. и&nbsp;+1% на&nbsp;других сроках при&nbsp;ежемесячном выполнении
            условия: от&nbsp;10 покупок по&nbsp;Халве на&nbsp;общую сумму
            от&nbsp;20&nbsp;000&nbsp;₽&sup3;
          </li>
          <li>
            <b>+1% к ставке по&nbsp;Копилке:</b> увеличение базовой ставки&#8308;
          </li>
          <li>
            <b>Комплексная ИТ-защита.</b> Онлайн-консультация эксперта при&nbsp;неисправностях
            и&nbsp;сбоях в&nbsp;работе компьютера или&nbsp;смартфона
          </li>
          <li>
            <b>Страхование покупок.</b> Возмещение при&nbsp;повреждении или&nbsp;поломке важных
            покупок, а&nbsp;также юридическая помощь по&nbsp;правам покупателей
          </li>
          <li>
            <b>Страхование жизни из&nbsp;здоровья.</b> Выплаты при&nbsp;несчастных случаях
            и&nbsp;болезни
          </li>
        </ul>
        <br />
        <p>
          Подключить подписку можно в&nbsp;
          <AppLink
            rel="nofollow noopener noreferrer"
            target="_blank"
            href="https://pwa.sovcombank.ru/"
          >
            приложении банка
          </AppLink>{" "}
          (выберите карту – подписка «ОПТИМА»), в&nbsp;чате{" "}
          <AppLink
            rel="nofollow noopener noreferrer"
            target="_blank"
            href="https://halvacard.ru/lk2/"
          >
            личного кабинета
          </AppLink>
          , по&nbsp;телефону горячей линии{" "}
          <AppLink rel="nofollow noopener noreferrer" target="_blank" href="tel:8-800-100-77-72">
            8-800-100-00-06
          </AppLink>{" "}
          или&nbsp;в&nbsp;любом{" "}
          <AppLink rel="nofollow noopener noreferrer" target="_blank" href="https://scb.ru/office">
            отделении
          </AppLink>{" "}
          банка.
        </p>
        <br />
        <p>
          &sup1; 1-й месяц бесплатно при&nbsp;условии, что&nbsp;клиент подключает подписку ВПЕРВЫЕ.
          Далее 3&nbsp;799 за&nbsp;год или&nbsp;399&nbsp;рублей за&nbsp;месяц (для&nbsp;социальных
          карт 2&nbsp;799 и&nbsp;299 рублей). Годовая подписка может стать полностью бесплатной
          при&nbsp;выполнении простых{" "}
          <AppLink
            rel="nofollow noopener noreferrer"
            target="_blank"
            href="https://optima.sovcombank.ru/credit-cards"
          >
            правил
          </AppLink>
          .
        </p>
        <p>
          &sup2; Ставка повышается в&nbsp;конце срока и&nbsp;начисляется на&nbsp;общую сумму вкладов
          в&nbsp;банке до&nbsp;1,5&nbsp;млн&nbsp;₽
        </p>
        <p>
          &sup3; Или платежей в&nbsp;разделе «Оплата услуг» в&nbsp;
          <AppLink
            rel="nofollow noopener noreferrer"
            target="_blank"
            href="https://pwa.sovcombank.ru/"
          >
            приложении банка
          </AppLink>
          . Для&nbsp;социальных карт от&nbsp;10&nbsp;000&nbsp;₽
        </p>
        <p>
          &#8308; По впервые открытым копилкам увеличенная базовая ставка начисляется первые
          3&nbsp;месяца на&nbsp;сумму свыше 1,5&nbsp;млн&nbsp;руб., с&nbsp;4-го&nbsp;месяца
          и&nbsp;по&nbsp;повторно открытым копилкам – на&nbsp;любую сумму
        </p>
      </>
    ),
  },
  {
    question: "Какие преимущества оформления кредитной карты в&nbsp;Совкомбанке?",
    answer: (
      <>
        <ul>
          <li>Длительный льготный период;</li>
          <li>Лимит кредитования до&nbsp;500&nbsp;000&nbsp;₽;</li>
          <li>
            Возможность снимать заёмные средства в&nbsp;любом банкомате БЕЗ&nbsp;комиссии
            и&nbsp;много другое.
          </li>
        </ul>
      </>
    ),
  },
  {
    question: "Сколько длится льготный период по&nbsp;кредитной карте?",
    answer: (
      <>
        До 300 дней в первый месяц с подпиской «Оптима». До 120 дней с подпиской «Оптима» со второго
        месяца (60 дней – без подписки). Делайте покупки сейчас, а погашайте задолженность позже и
        не платите проценты.
      </>
    ),
  },
  {
    question: "Можно ли снимать наличные с&nbsp;карты?",
    answer: <>Да, без комиссии в&nbsp;любом банкомате.</>,
  },
  {
    question: "Что такое льготный период?",
    answer: (
      <>
        Это период, во время которого банк не&nbsp;начисляет проценты за&nbsp;пользование кредитным
        лимитом.
      </>
    ),
  },
  {
    question: "Что такое обязательный минимальный платёж?",
    answer: (
      <>
        <p>
          Минимальный обязательный платёж (МОП) — часть от&nbsp;обязательного ежемесячного платежа,
          которую клиент должен внести к&nbsp;определенной дате. МОП включает неполную сумму
          задолженности, проценты и&nbsp;комиссии (если они есть).
        </p>
        <br />
        <p>Величина минимального платежа указывается в&nbsp;индивидуальных условиях договора.</p>
        <br />
        <p>
          Пени и штрафы, например, за&nbsp;нарушение графика платежей, не&nbsp;включены в&nbsp;МОП
          и&nbsp;оплачиваются отдельно.
        </p>
      </>
    ),
  },
  {
    question: "Почему могут отказать в&nbsp;получении карты?",
    answer: (
      <>
        Если клиент не соответствует требованиям или&nbsp;имеет плохую кредитную историю, банк может
        отказать в&nbsp;услуге.
      </>
    ),
  },
]

export const QUESTIONS_PKW_OLD = [
  {
    question: "Халва – кредитная или дебетовая карта?",
    answer:
      "Халва – универсальная карта, которую можно использовать одновременно как дебетовую и карту рассрочки*. Сменить режим можно легко в приложении «Халва – Совкомбанк». ",
  },
  {
    question: "Какой минимальный и максимальный лимит рассрочки*?",
    answer:
      "Минимальный лимит по карте «Халва» — 15 000 руб. Максимальный лимит составляет 500 000 руб.",
  },
  {
    question: "Влияет ли наличие карты на кредитную нагрузку?",
    answer:
      "Поскольку с помощью Халвы вы покупаете товары в рассрочку*, наличие задолженности по карте влияет на кредитную нагрузку. Банк будет относиться к вам более лояльно, если вы будете активно пользоваться картой и своевременно вносить платежи.  ",
  },
  {
    question: "Насколько надежен банк, который выпускает карту? Где о нем можно узнать информацию?",
    answer: (
      <>
        Халва — это проект Совкомбанка. Вся информация о его надежности — лицензии, реквизиты,
        рейтинги финансовой организации — собрана на{" "}
        <AppLink
          rel="nofollow noopener noreferrer"
          target="_blank"
          href="https://scb.ru/about/info"
        >
          отдельной странице
        </AppLink>
        .<br />
        <br /> Совкомбанк зарекомендовал себя как надежная организация и не раз лидировал в народных
        рейтингах:{" "}
        <ul>
          <li>
            в 2018 году «Халву»{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://finelita.ru/novosti/obyavleny-laureaty-xiv-premii-finansovaya-elita-rossii-2018.html"
            >
              признали
            </AppLink>{" "}
            лучшей банковской картой года, лауреат премии «Финансовая элита России»;
          </li>
          <li>
            по итогам 2024 года банк{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://www.banki.ru/services/responses/?date=2024"
            >
              возглавил
            </AppLink>{" "}
            «Народный рейтинг» портала «
            <AppLink rel="nofollow noopener noreferrer" target="_blank" href="http://banki.ru">
              Банки.ру
            </AppLink>
            », а до 2022{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://scb.ru/articles/novosti-kompanii/sovkombank-priznan-pobeditelem-narodnogo-reitinga-banki-ru-po-itogam-2022-goda"
            >
              занимал
            </AppLink>{" "}
            в нем первое место четыре года подряд;
          </li>
          <li>
            в 2024 году Совкомбанк первый в{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://www.sravni.ru/banki/rating/karty/"
            >
              рейтинге
            </AppLink>{" "}
            кредитных карт России по версии «
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://www.sravni.ru"
            >
              Сравни»
            </AppLink>{" "}
            (⭑4.91/5.00).
          </li>
        </ul>
      </>
    ),
  },
  {
    question: "Что такое подписка «Халва.Десятка»?",
    answer: (
      <>
        Это платная услуга, с&nbsp;которой вы получаете дополнительные преимущества:
        <ul>
          <li>
            <b>10 месяцев рассрочки на&nbsp;покупки.*</b> Единый увеличенный срок рассрочки*
            в&nbsp;260&nbsp;000{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://halvacard.ru/shops/special"
            >
              магазинах-партнёрах
            </AppLink>{" "}
            Халвы*;
          </li>
          <li>
            <b>
              Удвоение{" "}
              <AppLink
                rel="nofollow noopener noreferrer"
                target="_blank"
                href="https://scb.ru/document?id=2777"
              >
                кэшбэка
              </AppLink>
              .
            </b>{" "}
            В 2 раза больше кэшбэка за&nbsp;каждую покупку или поездку на Яндекс GO – возвращайте
            до&nbsp;10% от&nbsp;стоимости;
          </li>
          <li>
            <b>Увеличенный лимит кешбэка в&nbsp;месяц&nbsp;5&nbsp;000.</b> Получайте больше кешбэка
            по&nbsp;карте*****;
          </li>
          <li>
            <b>+5% к&nbsp;ставке вкладов.</b> Увеличение** на&nbsp;+5% по&nbsp;вкладам на&nbsp;сроке
            36&nbsp;мес., +2% на&nbsp;сроке 24 мес. (+1% на&nbsp;других сроках) при ежемесячном
            выполнении условия: от&nbsp;10 покупок по&nbsp;Халве на&nbsp;общую сумму
            от&nbsp;20&nbsp;000&nbsp;₽.***;
          </li>
          <li>
            <b>+1% к ставке Онлайн-копилки.</b> Увеличение базовой ставки***;
          </li>
          <li>
            <b>+1 месяц рассрочки*.</b> На снятия, переводы и&nbsp;покупки заёмными средствами
            не&nbsp;у&nbsp;партнеров;
          </li>
          <li>
            <b>Бесплатный стикер Рау.</b> Для удобной оплаты телефоном и&nbsp;повышенного кэшбэка;
          </li>
          <li>
            <b>Комплексная IT-защита.</b> Онлайн-консультация эксперта при неисправностях и сбоях в
            работе компьютера или смартфона;
          </li>
          <li>
            <b>Помощник по&nbsp;покупкам.</b> Личный консультант подберет для вас нужный товар
            с&nbsp;лучшей ценой и&nbsp;сроком рассрочки*;
          </li>
          <li>
            <b>Страхование жизни и&nbsp;здоровья.</b> Выплаты при несчастном случае
            или&nbsp;болезни;
          </li>
          <li>
            <b>Страхование покупок.</b> Возмещение при&nbsp;повреждении или&nbsp;поломке важных
            покупок, а&nbsp;также юридическая помощь по&nbsp;правам покупателей;
          </li>
        </ul>
        <p>
          * Если базовый срок рассрочки* партнёра превышает 10&nbsp;месяцев, то к&nbsp;покупке
          применяется базовый срок.
        </p>
        <p>
          ** Ставка повышается в&nbsp;конце срока и&nbsp;начисляется на&nbsp;общую сумму вкладов
          в&nbsp;банке до&nbsp;1,5 млн ₽.
        </p>
        <p>
          *** По впервые открытым копилкам увеличенная базовая ставка начисляется первые 3 месяца на
          сумму свыше 1,5 млн руб., с 4-го месяца и по повторно открытым копилкам — на любую сумму.
        </p>
        <p>**** Без подписки «Халва.Десятка» 3 000 баллов.</p>
      </>
    ),
  },
  {
    question: "Сколько времени рассматривают заявку на Халву?",
    answer:
      "Вы получите решение через несколько минут после того, как отправите заявку. В редких случаях на это может потребоваться 1 рабочий день.",
  },
  {
    question: "Что такое «зеленая цена» на&nbsp;Ozon?",
    answer: (
      <>
        Зелёная цена — это специальная сниженная стоимость товара. Она подсвечивается зелёным цветом
        в&nbsp;карточке товара / корзине в&nbsp;приложении «Ozon» и&nbsp;позволяет мгновенно
        получить скидку до&nbsp;30%. Данная скидка заменит кешбэк, который начисляться
        не&nbsp;будет.
      </>
    ),
  },
]

export const QUESTIONS_PRAVDA_COFFEE = [
  {
    question: "Что такое «зелёная цена» на Ozon?",
    answer:
      "Зеленая цена — это специальная сниженная стоимость товара. Она подсвечивается зелёным цветом в\u00A0карточке товара / корзине в\u00A0приложении «Ozon» и\u00A0позволяет мгновенно получить скидку до\u00A030%. Данная скидка заменит кешбэк, который начисляться не\u00A0будет.",
  },
  {
    question: "Халва – кредитная или дебетовая карта?",
    answer:
      "Халва – универсальная карта, которую можно использовать одновременно как\u00A0дебетовую и\u00A0карту рассрочки*. Сменить режим можно легко в\u00A0приложении «Халва – Совкомбанк». ",
  },
  {
    question: "Какой минимальный и\u00A0максимальный лимит рассрочки*?",
    answer:
      "Минимальный лимит по карте «Халва» — 15\u00A0000\u00A0руб. Максимальный лимит составляет 500\u00A0000\u00A0руб.",
  },
  {
    question: "Влияет ли наличие карты на\u00A0кредитную нагрузку?",
    answer:
      "Поскольку с\u00A0помощью Халвы вы покупаете товары в\u00A0рассрочку*, наличие задолженности по\u00A0карте влияет на\u00A0кредитную нагрузку. Банк будет относиться к\u00A0вам более лояльно, если вы будете активно пользоваться картой и\u00A0своевременно вносить платежи.  ",
  },
  {
    question:
      "Насколько надежен банк, который выпускает карту? Где о\u00A0нем можно узнать информацию?",
    answer: (
      <>
        Халва — это проект Совкомбанка. Вся информация о его надежности — лицензии, реквизиты,
        рейтинги финансовой организации — собрана на{" "}
        <AppLink
          rel="nofollow noopener noreferrer"
          target="_blank"
          href="https://scb.ru/about/info"
        >
          отдельной странице
        </AppLink>
        .<br />
        <br /> Совкомбанк зарекомендовал себя как надежная организация и&nbsp;не&nbsp;раз лидировал
        в&nbsp;народных рейтингах:{" "}
        <ul>
          <li>
            в 2018 году «Халву»{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://finelita.ru/novosti/obyavleny-laureaty-xiv-premii-finansovaya-elita-rossii-2018.html"
            >
              признали
            </AppLink>{" "}
            лучшей банковской картой года, лауреат премии «Финансовая элита России»;
          </li>
          <li>
            по итогам 2024 года банк{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://www.banki.ru/services/responses/?date=2024"
            >
              возглавил
            </AppLink>{" "}
            «Народный рейтинг» портала «
            <AppLink rel="nofollow noopener noreferrer" target="_blank" href="http://banki.ru">
              Банки.ру
            </AppLink>
            », а до 2022{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://scb.ru/articles/novosti-kompanii/sovkombank-priznan-pobeditelem-narodnogo-reitinga-banki-ru-po-itogam-2022-goda"
            >
              занимал
            </AppLink>{" "}
            в нем первое место четыре года подряд;
          </li>
          <li>
            в 2024 году Совкомбанк первый в{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://www.sravni.ru/banki/rating/karty/"
            >
              рейтинге
            </AppLink>{" "}
            кредитных карт России по версии «
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://www.sravni.ru"
            >
              Сравни»
            </AppLink>{" "}
            (⭑4.91/5.00).
          </li>
        </ul>
      </>
    ),
  },
  {
    question: "Что такое подписка «Халва.Десятка»?",
    answer: (
      <>
        Это платная услуга, с&nbsp;которой вы получаете дополнительные преимущества:
        <ul>
          <li>
            <b>10 месяцев рассрочки на&nbsp;покупки.*</b> Единый увеличенный срок рассрочки*
            в&nbsp;260&nbsp;000{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://halvacard.ru/shops/special"
            >
              магазинах-партнёрах
            </AppLink>{" "}
            Халвы*;
          </li>
          <li>
            <b>
              Удвоение{" "}
              <AppLink
                rel="nofollow noopener noreferrer"
                target="_blank"
                href="https://scb.ru/document?id=2777"
              >
                кешбэка
              </AppLink>
              .
            </b>{" "}
            В 2 раза больше кешбэка за&nbsp;каждую покупку или поездку на Яндекс GO – возвращайте
            до&nbsp;10% от&nbsp;стоимости;
          </li>
          <li>
            <b>Увеличенный лимит кешбэка в&nbsp;месяц&nbsp;5&nbsp;000.</b> Получайте больше кешбэка
            по&nbsp;карте*****;
          </li>
          <li>
            <b>+5% к&nbsp;ставке вкладов.</b> Увеличение** на&nbsp;+5% по&nbsp;вкладам на&nbsp;сроке
            36&nbsp;мес., +2% на&nbsp;сроке 24 мес. (+1% на&nbsp;других сроках) при ежемесячном
            выполнении условия: от&nbsp;10 покупок по&nbsp;Халве на&nbsp;общую сумму
            от&nbsp;20&nbsp;000&nbsp;₽.***;
          </li>
          <li>
            <b>+1% к ставке Онлайн-копилки.</b> Увеличение базовой ставки***;
          </li>
          <li>
            <b>+1 месяц рассрочки*.</b> На снятия, переводы и&nbsp;покупки заёмными средствами
            не&nbsp;у&nbsp;партнеров;
          </li>
          <li>
            <b>Бесплатный стикер Рау.</b> Для удобной оплаты телефоном и&nbsp;повышенного кешбэка;
          </li>
          <li>
            <b>Комплексная IT-защита.</b> Онлайн-консультация эксперта при неисправностях и сбоях в
            работе компьютера или смартфона;
          </li>
          <li>
            <b>Помощник по&nbsp;покупкам.</b> Личный консультант подберет для вас нужный товар
            с&nbsp;лучшей ценой и&nbsp;сроком рассрочки*;
          </li>
          <li>
            <b>Страхование жизни и&nbsp;здоровья.</b> Выплаты при несчастном случае
            или&nbsp;болезни;
          </li>
          <li>
            <b>Страхование покупок.</b> Возмещение при&nbsp;повреждении или&nbsp;поломке важных
            покупок, а&nbsp;также юридическая помощь по&nbsp;правам покупателей;
          </li>
        </ul>
        <p>
          * Если базовый срок рассрочки* партнёра превышает 10&nbsp;месяцев, то к&nbsp;покупке
          применяется базовый срок.
        </p>
        <p>
          ** Ставка повышается в&nbsp;конце срока и&nbsp;начисляется на&nbsp;общую сумму вкладов
          в&nbsp;банке до&nbsp;1,5 млн ₽.
        </p>
        <p>
          *** По впервые открытым копилкам увеличенная базовая ставка начисляется первые 3 месяца на
          сумму свыше 1,5 млн руб., с 4-го месяца и по повторно открытым копилкам — на любую сумму.
        </p>
        <p>**** Без подписки «Халва.Десятка» 3 000 баллов.</p>
      </>
    ),
  },
  {
    question: "Сколько времени рассматривают заявку на\u00A0Халву?",
    answer:
      "Вы получите решение через несколько минут после того, как отправите заявку. В\u00A0редких случаях на\u00A0это может потребоваться 1 рабочий день.",
  },
]
